import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/icons.css";

import "jquery-ui-bundle/jquery-ui.css";
import "../../assets/css/style.css";
import swal from "sweetalert";
import $ from "jquery";
import "jquery-ui-bundle";

import { SERVER_IP, PORT, ud, jwt, auth_response_flow, sample_csv, LICENSE } from "../../Server";
import axios from "axios";
import { withRouter } from "react-router-dom";
import Csv_Validate from "./CSV_Workflow";
import { CloseIcon, DeleteRedIcon, EditIcon, HomeIcon, NotifyIcon, PLusIcon, PLusIconDark } from "../../assets/Icons";
import { connect } from "react-redux";
import HeaderMobileSearch from "../../common/HeaderMobileSearch";
import NoDataFound from "../../common/NoDataFound";
import ImportFromLibrary from "./ImportFromLibrary";
import BackBtn from "../../common/BackBtn";
var version_info = JSON.parse(sessionStorage.getItem("version_info"));

const initialState = {
  bankSelected: false,
  p_c_question_type: "",
  question_pc_bank: "",
  selectionType: "none",
  SelectedBankTypeForCreateBank: "MCQ",
  createBank: true,
  selectedMcqBankIdForTask: "",
  selectedRangeBankIdForTask: "",
  selectedParentChildBankIdForTask: "",
  selectedBank: "MCQ",
  // Mcq Question Bank State
  quectionMcq: "",
  correctAnsMcq: "",
  alt1AnsMcq: "",
  alt2AnsMcq: "",
  alt3AnsMcq: "",
  McqTypeBank: "",
  mcqIsMandatry: true,

  // Range Question Bank State
  quectionRange: "",
  minRange: "",
  maxRange: "",
  rangeIsMandatry: true,
  //bank list

  isMandatryCheck: true,
  selectedNodeIDForPC: undefined,

  // SubTask  "none", "next"
  subtask_type: "none",
  selectedRadioTaskLevel2: "",
  option_type_task_L2: "",
  clicked_task_L2: "",
  isMandatryCheckL2: true,

  createBankRangeOnP_C: false,
  createBankMcqOnP_C: false,
  editMode: 0,
  editJson: {},
  publishLoader: false,
  rangeIsMandatryP_C: true,
  publishPopup: false,
  childsAddBank: false,
  question_pc_sub: "",
  parentListing: [{ id: 1, parent_id: 0, task_type: 3, value: "New Parent", is_mandatory: 1 }],
  SelectedMcqOrRangePC: "MCQ",
  selectedBankIdForTaskChild: 0,
  parentChildSelectedList: {},
  parentListingConverted: [],
  is_mandatoryEdit: true,
};

class CreateTaskBank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bankSelected: false,
      p_c_question_type: "",
      question_pc_bank: "",
      allTasks: [],
      listParentChild: [],
      selectionType: "none",
      SelectedBankTypeForCreateBank: "MCQ",
      createBank: true,
      selectedMcqBankIdForTask: "",
      selectedRangeBankIdForTask: "",
      selectedParentChildBankIdForTask: "",
      selectedBank: "MCQ",

      // Mcq Question Bank State
      quectionMcq: "",
      correctAnsMcq: "",
      alt1AnsMcq: "",
      alt2AnsMcq: "",
      alt3AnsMcq: "",
      McqTypeBank: "",
      mcqIsMandatry: true,

      // Range Question Bank State
      quectionRange: "",
      minRange: "",
      maxRange: "",
      rangeIsMandatry: true,
      //bank list
      mcqBankList: [],
      rangeBankList: [],
      parentChildBankList: [],
      isMandatryCheck: true,
      selectedNodeIDForPC: undefined,

      // SubTask  "none", "next"
      subtask_type: "none",
      tasksListForTrigger: [],
      selectedRadioTaskLevel2: "",
      option_type_task_L2: "",
      clicked_task_L2: "",
      isMandatryCheckL2: true,
      createBankRangeOnP_C: false,
      createBankMcqOnP_C: false,
      message: "",

      // Edit Tasks
      editMode: 0,
      editJson: {},
      publishLoader: false,
      rangeIsMandatryP_C: true,
      childsAddBank: false,
      question_pc_sub: "",
      parentListing: [{ id: 1, parent_id: 0, task_type: 3, value: "New Parent", is_mandatory: 1 }],
      SelectedMcqOrRangePC: "MCQ",
      selectedBankIdForTaskChild: 0,
      parentListingConverted: [],
      parentChildSelectedList: {},
      is_mandatoryEdit: true,

      // csv file
      csv_file: "",
      uploadCsv: false,
      csv_data: [],
      csv_info_popup: false,
    };
    // If you're not using arrow functions, bind methods:
    this.fetchMcqBankList = this.fetchMcqBankList.bind(this);
    this.fetchTaskList = this.fetchTaskList.bind(this);
  }
  state = {
    
  };

  updateStateValue = () => {
    this.setState({ selectedBank: "MCQ", SelectedBankTypeForCreateBank: "MCQ", createBank: true });
    this.fetchMcqBankList();
  };

  addParentChild = (node) => {
    $("input:radio[name='parent_child_list']").each(function (i) {
      this.checked = false;
    });
    this.setState({ selectedParentChildBankIdForTask: "", parentChildSelectedList: "" });

    this.setState({ selectedNodeIDForPC: node.id });
  };

  componentWillMount() {
    if (
      sessionStorage.getItem("selected_workflow") == null ||
      sessionStorage.getItem("selected_workflow") == undefined ||
      sessionStorage.getItem("selected_workflow") === ""
    ) {
      // window.location.href = "/create/workflow";
      this.props.history.push("/create/workflow");
      return;
    }

    this.setState({ parentListingConverted: this.convertWithIndex(this.state.parentListing) });
    this.dataByLicense();
  }

  dataByLicense = () => {
    if (LICENSE.application_Dashboard) {
      this.setState(this.state);
    } else {
      setTimeout(() => {
        this.dataByLicense();
      }, 1000);
    }
  };

  selectedMcqOrRangePC = (e) => {
    this.setState({ SelectedMcqOrRangePC: e.target.value });
    this.fetchMcqBankList();
    this.fetchRangeBankList();
  };

  selectedMcqType = (e) => {
    this.setState({ McqTypeBank: e.target.value });
  };

  selectedEdit = (e) => {
    this.setState({ McqTypeBankEdit: e.target.value });
  };

  selectedBank = (e) => {
    this.setState({ selectedBank: e.target.value, SelectedBankTypeForCreateBank: e.target.value });
    if (e.target.value === "MCQ") {
      this.fetchMcqBankList();
    } else if (e.target.value === "Range") {
      this.fetchRangeBankList();
    } else if (e.target.value === "ParentChild") {
      this.fetchParentChildBankList();
    }
  };
  resetAllState = () => {
    this.setState(initialState);
  };
  onChangeInputCreateParent = (e) => {
    this.setState({ p_c_question_type: e.target.value });
    if (e.target.value == 1) {
      this.fetchMcqBankList();
    } else if (e.target.value == 2) {
      this.fetchRangeBankList();
    } else if (e.target.value == 3) {
      this.fetchParentChildBankList();
    }
  };
  SaveMcqBank = () => {
    var data;
    var _this = this;
    if (this.state.McqTypeBank === "mcq") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: this.state.quectionMcq,
        correct: this.state.correctAnsMcq,
        alternative1: this.state.alt1AnsMcq,
        alternative2: this.state.alt2AnsMcq,
        alternative3: this.state.alt3AnsMcq,
        is_mandatory: this.state.mcqIsMandatry ? 1 : 0,
        version_id: version_info.id,
        mcq_type: 1,
      };
    } else {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: this.state.quectionMcq,
        correct: this.state.correctAnsMcq,
        alternative1: this.state.alt1AnsMcq,
        is_mandatory: this.state.mcqIsMandatry ? 1 : 0,
        version_id: version_info.id,
        mcq_type: 2,
      };
    }
    if (this.state.selectionType === "task") {
      let headers = {
        user_id: ud.id.toString(),
        session_id: ud.session_id.toString(),
        user_type: ud.usertype.toString(),
        main_id: ud.main_id.toString(),
        jwt_token: jwt,
        c_id: ud.c_id.toString(),
      };
      axios
        .post(`${SERVER_IP}/workflowTasksMCQ`, data, { withCredentials: true, headers: headers })
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.error === false) {
              swal(response.data.message, "", "success");
              _this.resetAllState();
              _this.fetchTaskList();
              return;
            } else {
              // swal(response.data.message, "", "warning");
              auth_response_flow(response.data, (return_response) => {
                if (return_response.error === false && return_response.retry === true) {
                  _this.SaveMcqBank();
                }
              });
            }
          }
        })
        .catch(function (error) {
          swal("Something Went Wrong. Please Retry.", "", "warning");
        });
    } else if (this.state.selectionType === "subtasklevel2") {
      var _this = this;

      if (data.question == "" || data.correct == "" || data.alternative1 == "") {
        swal("Question, Option 1, and Option 2 are always compulsory.", "", "warning");
        return;
      }
      let headers = {
        user_id: ud.id.toString(),
        session_id: ud.session_id.toString(),
        user_type: ud.usertype.toString(),
        main_id: ud.main_id.toString(),
        jwt_token: jwt,
        c_id: ud.c_id.toString(),
      };
      axios
        .post(`${SERVER_IP}/bank/MCQCreate`, data, { withCredentials: true, headers: headers })
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.error === false) {
              _this.setState({
                selectedRangeBankIdForTask: response.data.id,
                selectedMcqBankIdForTask: response.data.id,
              });
              if (_this.state.childsAddBank) {
                _this.CreateSubTasksPCFromBank("MCQ", _this.state.mcqIsMandatry);
              } else {
                _this.AddTaskFromBankLevel2Banks("MCQ", _this.state.mcqIsMandatry);
              }
              return;
            } else {
              // swal(response.data.message, "", "warning")
              auth_response_flow(response.data, (return_response) => {
                if (return_response.error === false && return_response.retry === true) {
                  _this.SaveMcqBank();
                }
              });
            }
          }
        })
        .catch(function (error) {
          swal("Something Went Wrong. Please Retry.", "", "warning");
        });
    }
  };
  saveMcqBankDataOnPC = () => {
    var data;
    var _this = this;
    if (this.state.McqTypeBank === "mcq") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: this.state.quectionMcq,
        correct: this.state.correctAnsMcq,
        alternative1: this.state.alt1AnsMcq,
        alternative2: this.state.alt2AnsMcq,
        alternative3: this.state.alt3AnsMcq,
        is_mandatory: this.state.mcqIsMandatry ? 1 : 0,
        mcq_type: 1,
      };
    } else {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: this.state.quectionMcq,
        correct: this.state.correctAnsMcq,
        alternative1: this.state.alt1AnsMcq,
        is_mandatory: this.state.mcqIsMandatry ? 1 : 0,
        mcq_type: 2,
      };
    }

    var _this = this;
    if (data.question == "" || data.correct == "" || data.alternative1 == "") {
      swal("Question, Option 1, And Option 2 Is Always Compulsory.", "", "warning");
      return;
    }
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/MCQCreate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            _this.setState({
              createBankMcqOnP_C: false,
              quectionMcq: "",
              correctAnsMcq: "",
              alt1AnsMcq: "",
              alt2AnsMcq: "",
              alt3AnsMcq: "",
              mcqIsMandatry: true,
              McqTypeBank: "",
            });
            _this.fetchMcqBankList();
            swal(response.data.message, "", "success");
            return;
          } else {
            // swal(response.data.message, "", "warning")
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.saveMcqBankDataOnPC();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  SaveRangeBank = () => {
    var data = {
      sid: ud.main_id,
      workflow_id: sessionStorage.getItem("selected_workflow"),
      question: this.state.quectionRange,
      max_value: this.state.maxRange,
      min_value: this.state.minRange,
      is_mandatory: this.state.rangeIsMandatry ? 1 : 0,
      version_id: version_info.id,
    };
    var _this = this;
    if (this.state.selectionType === "task") {
      let headers = {
        user_id: ud.id.toString(),
        session_id: ud.session_id.toString(),
        user_type: ud.usertype.toString(),
        main_id: ud.main_id.toString(),
        jwt_token: jwt,
        c_id: ud.c_id.toString(),
      };
      axios
        .post(`${SERVER_IP}/workflowTasksRange`, data, { withCredentials: true, headers: headers })
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.error === false) {
              swal(response.data.message, "", "success");
              _this.resetAllState();
              _this.fetchTaskList();
            } else {
              auth_response_flow(response.data, (return_response) => {
                if (return_response.error === false && return_response.retry === true) {
                  _this.SaveRangeBank();
                }
              });
            }
          }
        })
        .catch(function (error) {
          swal("Something Went Wrong. Please Retry.", "", "warning");
        });
    } else if (this.state.selectionType === "subtasklevel2") {
      if (data.question == "" || data.max_value == "" || data.min_value == "") {
        swal("Question, Max, And Min Is Always Compulsory.", "", "warning");
        return;
      } else if (Number(data.min_value) == Number(data.max_value)) {
        swal("Minimum Value and Maximum Value should not be the same.", "", "warning");
        return;
      }
      let headers = {
        user_id: ud.id.toString(),
        session_id: ud.session_id.toString(),
        user_type: ud.usertype.toString(),
        main_id: ud.main_id.toString(),
        jwt_token: jwt,
        c_id: ud.c_id.toString(),
      };

      axios
        .post(`${SERVER_IP}/bank/RangeCreate`, data, { withCredentials: true, headers: headers })
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.error == false) {
              _this.setState({
                selectedRangeBankIdForTask: response.data.id,
                selectedMcqBankIdForTask: response.data.id,
              });
              if (_this.state.childsAddBank) {
                _this.CreateSubTasksPCFromBank("Range", _this.state.rangeIsMandatry);
              } else {
                _this.AddTaskFromBankLevel2Banks("Range", _this.state.rangeIsMandatry);
              }
              return;
            } else {
              // swal(response.data.message, "", "success");
              // _this.setState({ SelectedBankTypeForCreateBank: "" })
              _this.fetchRangeBankList();
              auth_response_flow(response.data, (return_response) => {
                if (return_response.error === false && return_response.retry === true) {
                  _this.SaveRangeBank();
                }
              });
            }
          }
        })
        .catch(function (error) {
          swal("Something Went Wrong. Please Retry.", "", "warning");
        });
    }
  };
  saveRangeBankDataOnPC = () => {
    var data = {
      sid: ud.main_id,
      workflow_id: sessionStorage.getItem("selected_workflow"),
      question: this.state.quectionRange,
      max_value: this.state.maxRange,
      min_value: this.state.minRange,
      is_mandatory: this.state.rangeIsMandatry ? 1 : 0,
    };
    var _this = this;
    if (data.question == "" || data.max_value == "" || data.min_value == "") {
      swal("Question, Max, And Min Is Always Compulsory.", "", "warning");
      return;
    } else if (Number(data.min_value) >= Number(data.max_value)) {
      swal("Max Value Is Always Greater Then Min Value.", "", "warning");
      return;
    }
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/RangeCreate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message);
            _this.setState({
              createBankRangeOnP_C: false,
              quectionRange: "",
              max_value: "",
              min_value: "",
              is_mandatory: "",
            });
            _this.fetchRangeBankList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.saveRangeBankDataOnPC();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  saveParentChildBankForP = () => {
    if (this.state.question_pc_bank === "") {
      swal("Please Fill The Parent.", "", "warning");
      return;
    }
    var data = {
      sid: ud.main_id,
      parent_id: 0,
      question: this.state.question_pc_bank,
      child_type: 3,
      bank_id: 0,
      is_mandatory: 1,
    };

    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/ParentChildCreate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message, "", "success");
            _this.setState({ createBank: false, question_pc_bank: "" });
            _this.fetchParentChildBankList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.saveParentChildBankForP();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  saveParentChildBankForC = (child_type, calledFromImportLibrary = false) => {
    var data;
    if (child_type == 1) {
      data = {
        sid: ud.main_id,
        parent_id: this.state.selectedNodeIDForPC,
        question: "",
        child_type: 1,
        bank_id: this.state.selectedMcqBankIdForTask,
        is_mandatory: this.state.rangeIsMandatryP_C ? 1 : 0,
      };
    } else if (child_type == 2) {
      data = {
        sid: ud.main_id,
        parent_id: this.state.selectedNodeIDForPC,
        question: "",
        child_type: 2,
        bank_id: this.state.selectedRangeBankIdForTask,
        is_mandatory: this.state.rangeIsMandatryP_C ? 1 : 0,
      };
    } else if (child_type == 3) {
      if (!calledFromImportLibrary && this.state.question_pc_bank === "") {
        swal("Please Fill The Parent.", "", "warning");
        return;
      }
      data = {
        sid: ud.main_id,
        parent_id: this.state.selectedNodeIDForPC,
        question: this.state.question_pc_bank,
        child_type: 3,
        bank_id: this.state.selectedParentChildBankIdForTask || 0,
        is_mandatory: this.state.rangeIsMandatryP_C ? 1 : 0,
      };
    } else {
      return;
    }
    if (data.bank_id === "") {
      return;
    }

    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/ParentChildCreate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message, "", "success");
            _this.setState({
              selectedRangeBankIdForTask: "",
              selectedMcqBankIdForTask: "",
              p_c_question_type: null,
              selectedNodeIDForPC: undefined,
            });
            _this.fetchParentChildBankList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.saveParentChildBankForC();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };

  onChangeInput = (e) => {
    e.preventDefault();

    this.setState({ [e.target.name]: e.target.value });
  };
  handleCheckbox = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.checked });
  };

  componentDidMount() {
    $(function () {
      $(".sortable").sortable();
      $(".sortable").disableSelection();
    });

    this.updateStateValue();
    this.fetchTaskList();
  }

  fetchTaskList = () => {
    var data = {
      workflow_id: sessionStorage.getItem("selected_workflow"),
      version_id: version_info.id,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workflowTasks`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.status.error === false) {
            if (response.data.taskDetails) {
              if (response.data.status.is_published == 1) {
                // window.location.href = "/create/publishedtask";
                this.props.history.push("/create/publishedtask");
                return;
              }
              _this.setState({
                allTasks: response.data.taskDetails,
                // message: response.data.taskDetails.length === 0 ? "No Record Found." : "",
                message: response.data.taskDetails.length === 0 ? <NoDataFound headText={`No Record Found.`} /> : "",
                publishStatus: response.data.taskDetails.length > 0 ? "publish" : "unpublish",
              });
            }
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.fetchTaskList();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };

  addTask = () => {
    this.resetAllState();
    this.setState({ selectionType: "task" });
  };

  createBank = () => {
    var SelectedBankType = $('input[name="SelectBankType"]:checked').val();
    this.setState({ SelectedBankTypeForCreateBank: SelectedBankType, createBank: true });
  };
  fetchMcqBankList = () => {
    var data = { sid: ud.main_id };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/MCQList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            if (response.data.listMCQ) {
              _this.setState({ mcqBankList: response.data.listMCQ });
            }
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.fetchMcqBankList();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  fetchRangeBankList = () => {
    var data = { sid: ud.main_id };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/RangeList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            if (response.data.listRange) {
              _this.setState({ rangeBankList: response.data.listRange });
            }
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.fetchRangeBankList();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  fetchParentChildBankList = () => {
    var data = { sid: ud.main_id };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/ParentChildList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            if (response.data.listParentchild) {
              var parentChild = _this.convert(response.data.listParentchild);
              _this.setState({ listParentChild: parentChild });
            }
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.fetchParentChildBankList();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  convert = (array) => {
    const map = {};
    const roots = [];

    // Initialize map and add empty children arrays
    array.forEach((obj) => {
      map[obj.id] = { ...obj, children: [] }; // clone to avoid mutating original
    });

    array.forEach((obj) => {
      const parentId = obj.parent_id;
      if (parentId === null || parentId === 0 || !map[parentId]) {
        // This is a root node
        roots.push(map[obj.id]);
      } else {
        // Add to parent's children
        map[parentId].children.push(map[obj.id]);
      }
    });

    return roots;
  };

  convertWithIndex = (array) => {
    var map = {};
    var lastIndex = 0;
    for (var i = 0; i < array.length; i++) {
      var obj = array[i];
      obj.children = [];
      obj.index = i;
      map[obj.id] = obj;

      var parent_id = obj.parent_id || "-";
      if (!map[parent_id]) {
        map[parent_id] = {
          children: [],
        };
      }
      lastIndex = lastIndex + 1;
      map[parent_id].children.push(obj);
    }
    this.setState({ TotalNoIndexChild: lastIndex });
    return map["-"].children;
  };
  radioMcqBankSelect = (e) => {
    this.setState({ selectedMcqBankIdForTask: e.target.value });
  };
  radioMcqBankSelectChild = (e) => {
    this.setState({ selectedBankIdForTaskChild: e.target.value });
  };
  radioTaskLevel2 = (e) => {
    this.setState({ selectedRadioTaskLevel2: e.target.value });
  };
  radioRangeBankSelect = (e) => {
    this.setState({ selectedRangeBankIdForTask: e.target.value });
  };
  radioRangeBankSelectChild = (e) => {
    this.setState({ selectedBankIdForTaskChild: e.target.value });
  };
  radioParentChildBankSelect = (e) => {
    var temp_value = JSON.parse(e.target.value);

    this.setState({ selectedParentChildBankIdForTask: temp_value.id, parentChildSelectedList: temp_value });

    return;
  };

  addTaskFromBank = (e, calledFromImportLibrary = false) => {
    if (this.state.selectionType === "task") {
      this.AddTaskFromBankDirectly(calledFromImportLibrary);
    } else if (this.state.selectionType === "subtasklevel2") {
      if (this.state.childsAddBank) {
        this.AddSubTasksPCFromBank();
      } else {
        this.AddTaskFromBankLevel2();
      }
    }
  };

  AddTaskFromBankLevel2 = () => {
    var data;
    if (this.state.selectedBank === "MCQ") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        version_id: version_info.id,
        task_id: this.state.clicked_task_L2.task_id,
        option_type: this.state.option_type_task_L2,
        type: 1,
        trigger_bank_id: Number(this.state.selectedMcqBankIdForTask),
        is_mandatory: this.state.isMandatryCheck === true ? 1 : 0,
      };
    } else if (this.state.selectedBank === "Range") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        version_id: version_info.id,
        task_id: this.state.clicked_task_L2.task_id,
        option_type: this.state.option_type_task_L2,
        type: 2,
        trigger_bank_id: Number(this.state.selectedRangeBankIdForTask),
        is_mandatory: this.state.isMandatryCheck === true ? 1 : 0,
      };
    } else if (this.state.selectedBank === "ParentChild") {
      var total_child = this.TotalCountTaskChild(this.state.parentChildSelectedList, []);
      if (total_child) {
        swal(
          "Note: Every Main Question/Parent Question should have a Child/Sub Question. Please create a Child/Sub Question for the same.",
          "",
          "warning"
        );
        return;
      }
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        version_id: version_info.id,
        task_id: this.state.clicked_task_L2.task_id,
        option_type: this.state.option_type_task_L2,
        type: 3,
        trigger_bank_id: Number(this.state.selectedParentChildBankIdForTask),
        is_mandatory: this.state.isMandatryCheck === true ? 1 : 0,
      };
    }

    if (data == undefined) {
      return;
    } else if (data.trigger_bank_id == 0) {
      return;
    }

    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workFlowTasksL2`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message, "", "success");
            _this.resetAllState();
            _this.fetchTaskList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.AddTaskFromBankLevel2();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  AddTaskFromBankLevel2Banks = (optiontype, is_mandatory) => {
    var data;

    if (optiontype === "MCQ") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        version_id: version_info.id,
        task_id: this.state.clicked_task_L2.task_id,
        option_type: this.state.option_type_task_L2,
        type: 1,
        trigger_bank_id: Number(this.state.selectedMcqBankIdForTask),
        is_mandatory: is_mandatory === true ? 1 : 0,
      };
    } else if (optiontype === "Range") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        version_id: version_info.id,
        task_id: this.state.clicked_task_L2.task_id,
        option_type: this.state.option_type_task_L2,
        type: 2,
        trigger_bank_id: Number(this.state.selectedRangeBankIdForTask),
        is_mandatory: is_mandatory === true ? 1 : 0,
      };
    } else {
      return;
    }
    if (data == undefined) {
      return;
    } else if (data.trigger_bank_id == 0) {
      return;
    }
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workFlowTasksL2`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message, "", "success");
            _this.resetAllState();
            _this.fetchTaskList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.AddTaskFromBankLevel2Banks();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };

  AddTaskFromBankDirectly = (calledFromImportLibrary) => {
    var data;

    if (this.state.selectedBank === "MCQ") {
      data = {
        workflow_id: sessionStorage.getItem("selected_workflow"),
        task_type: 1,
        bank_id: this.state.selectedMcqBankIdForTask,
        is_mandatory: this.state.isMandatryCheck ? 1 : 0,
        sid: ud.main_id,
        version_id: version_info.id,
      };
    } else if (this.state.selectedBank === "Range") {
      data = {
        workflow_id: sessionStorage.getItem("selected_workflow"),
        task_type: 2,
        bank_id: this.state.selectedRangeBankIdForTask,
        is_mandatory: this.state.isMandatryCheck ? 1 : 0,
        sid: ud.main_id,
        version_id: version_info.id,
      };
    } else if (this.state.selectedBank === "ParentChild") {
      if (!calledFromImportLibrary) {
        var total_child = this.TotalCountTaskChild(this.state.parentChildSelectedList, []);
      }
      console.log(this.state.parentChildSelectedList, calledFromImportLibrary, "line 1093");
      if (total_child) {
        swal(
          "Note: Every Main Question/Parent Question should have a Child/Sub Question. Please create a Child/Sub Question for the same.",
          "",
          "warning"
        );
        return;
      }

      data = {
        workflow_id: sessionStorage.getItem("selected_workflow"),
        task_type: 3,
        bank_id: this.state.selectedParentChildBankIdForTask,
        is_mandatory: this.state.isMandatryCheck ? 1 : 0,
        sid: ud.main_id,
        version_id: version_info.id,
      };
    } else {
      data = {
        bank_id: "",
      };
    }
    this.setState({
      selectedMcqBankIdForTask: "",
      selectedRangeBankIdForTask: "",
      selectedParentChildBankIdForTask: "",
    });
    if (data.bank_id == "") {
      return;
    }

    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workflowTasksExist`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message, "", "success");
            _this.resetAllState();
            _this.fetchTaskList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.AddTaskFromBankDirectly();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  validJsonInChildCreate = (array, LastTaskType, TotalCount, currentCount, processData) => {
    if (TotalCount === currentCount.length) {
      if (LastTaskType.length == 0) {
        var data = {
          sid: ud.main_id,
          workflow_id: sessionStorage.getItem("selected_workflow"),
          parent_id: this.state.subTaskParentId,
          subtasks: processData,
          child_type: 3,
        };
        this.addChildToTaskAPICall(data);
        return;
      } else {
        swal(
          "Note: Every Main Question/Parent Question should have a Child/Sub Question. Please create a Child/Sub Question for the same.",
          "",
          "warning"
        );
        return;
      }
    }
    array.map((list, index) => {
      if (list.children.length == 0 && list.task_type == 3) {
        LastTaskType.push(list);
      }
      currentCount.push(list);
      this.validJsonInChildCreate(list.children, LastTaskType, TotalCount, currentCount, processData);
    });
  };

  flattenChild = (childObj, parentId, level) => {
    var idAttr = "id";
    var parentAttr = "p_id";
    var childrenAttr = "children";
    var levelAttr = "level";
    var _this = this;

    var array = [];
    var childCopy = Object.assign({}, childObj);
    childCopy[levelAttr] = level;
    childCopy[parentAttr] = parentId;
    delete childCopy[childrenAttr];
    array.push(childCopy);
    array = array.concat(_this.processChildren(childObj, level));
    return array;
  };

  processChildren = (obj, level) => {
    var idAttr = "id";
    var parentAttr = "p_id";
    var childrenAttr = "children";
    var levelAttr = "level";
    var _this = this;
    if (!level) level = 0;
    var array = [];
    if (obj[childrenAttr]) {
      obj[childrenAttr].forEach(function (childObj) {
        array = array.concat(_this.flattenChild(childObj, obj[idAttr], level + 1));
      });
    }
    return array;
  };

  isMandatryCheckbox = (e) => {
    this.setState({ isMandatryCheck: !this.state.isMandatryCheck });
  };
  isMandatryCheckboxForLevel2 = (e) => {
    this.setState({ isMandatryCheckL2: !this.state.isMandatryCheckL2 });
  };
  hideBankOption = () => {
    // this.setState({ selectionType: "none" })
    this.resetAllState();
  };
  subTaskPlusClick = (node, option_type) => {
    // var task = this.state.allTasks.find(x => x.task_id === node.task_id);
    var temp = JSON.parse(JSON.stringify(this.state.allTasks));
    var index = this.state.allTasks.indexOf(node);

    var tasks = temp.splice(index, 1);

    this.setState({
      selectionType: "subtask",
      tasksListForTrigger: temp,
      option_type_task_L2: option_type,
      clicked_task_L2: node,
    });
  };
  SaveTaskLavel2 = () => {
    if (this.state.selectedRadioTaskLevel2 == "") {
      return;
    }
    var data = {
      sid: ud.main_id,
      workflow_id: sessionStorage.getItem("selected_workflow"),
      version_id: version_info.id,
      task_id: this.state.clicked_task_L2.task_id,
      option_type: this.state.option_type_task_L2,
      type: 4,
      trigger_bank_id: Number(this.state.selectedRadioTaskLevel2),
      is_mandatory: this.state.isMandatryCheckL2 === true ? 1 : 0,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workFlowTasksL2`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message, "", "success");
            _this.resetAllState();
            _this.fetchTaskList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.SaveTaskLavel2();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  deleteTasks = (id, delete_type) => {
    var data = {
      id: id,
      delete_type: JSON.stringify(delete_type),
      workflow_id: sessionStorage.getItem("selected_workflow"),
      version_id: version_info.id,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workflowTaskDelete`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            // window.location.reload()
            swal(response.data.message, "", "success");
            _this.resetAllState();
            //  setTimeout(() => window.location.reload(), 2000);
            setTimeout(() => _this.fetchTaskList(), 1000);
          } else {
            // swal(response.data.message, "", "warning");
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.deleteTasks();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  editTasks = (node, optionType) => {
    this.resetAllState();

    if (node.task_type == 1) {
      this.setState({
        editMode: node.task_type,
        editJson: node,
        McqTypeBankEdit: node.task[0].mcq_type,
        questionMcqEdit: node.task[0].question,
        correctMcqEdit: node.task[0].correct,
        alt1McqEdit: node.task[0].alternative_1,
        alt2McqEdit: node.task[0].alternative_2,
        alt3McqEdit: node.task[0].alternative_3,
        is_mandatoryEdit: node.is_mandatory == 1 ? true : false,
        optionType: optionType,
      });
    } else if (node.task_type == 2) {
      this.setState({
        editMode: node.task_type,
        editJson: node,
        questionRangeEdit: node.task[0].question,
        maxRangeEdit: node.task[0].max_value,
        minRangeEdit: node.task[0].min_value,
        is_mandatoryEdit: node.is_mandatory == 1 ? true : false,
        optionType: optionType,
      });
    } else if (node.task_type == 3) {
      this.setState({
        editMode: node.task_type,
        editJson: node,
        questionParentEdit: node.task[0].question,
        is_mandatoryEdit: node.is_mandatory == 1 ? true : false,
        optionType: optionType,
      });
      return;
    }
  };
  closeEditContainer = () => {
    this.resetAllState();
    // this.fetchTaskList();
  };
  onUpdateEvent = () => {
    var data;
    if (this.state.editMode == 1) {
      data = {
        task_type: this.state.editMode,
        mcq_type: this.state.McqTypeBankEdit,
        question: this.state.questionMcqEdit,
        correct: this.state.correctMcqEdit,
        alternative_1: this.state.alt1McqEdit,
        alternative_2: this.state.alt2McqEdit,
        alternative_3: this.state.alt3McqEdit,
        id: this.state.editJson.bank_id,
        optionType: this.state.optionType,
        task_id: this.state.editJson.task_id,
        is_mandatory: this.state.is_mandatoryEdit ? 1 : 0,
      };
    } else if (this.state.editMode == 2) {
      data = {
        task_type: this.state.editMode,
        question: this.state.questionRangeEdit,
        max_value: this.state.maxRangeEdit,
        min_value: this.state.minRangeEdit,
        id: this.state.editJson.bank_id,
        optionType: this.state.optionType,
        task_id: this.state.editJson.task_id,
        is_mandatory: this.state.is_mandatoryEdit ? 1 : 0,
      };
    } else if (this.state.editMode == 3) {
      data = {
        task_type: this.state.editMode,
        question: this.state.questionParentEdit,
        id: this.state.optionType == "mainTask" ? this.state.editJson.task[0].task_id : this.state.editJson.task_id,
        optionType: this.state.optionType,
        task_id: this.state.optionType == "mainTask" ? this.state.editJson.task_id : this.state.editJson.subTask_id,
        is_mandatory: this.state.is_mandatoryEdit ? 1 : 0,
      };
    } else {
      return;
    }
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workflowEditTaskSubTask`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message, "", "success");
            _this.resetAllState();
            _this.fetchTaskList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.onUpdateEvent();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  publishClick = () => {
    this.resetAllState();
    this.setState({ publishPopup: true });
  };
  publishVersion = () => {
    var data = {
      workflow_id: sessionStorage.getItem("selected_workflow"),
      version_id: version_info.id,
      description: this.state.descriptionPublish,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workFlowPublish`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.status.error === false) {
            _this.resetAllState();
            _this.setState({ publishLoader: true })
            setTimeout(() => {
              _this.setState({ publishLoader: false });
              _this.props.history.push("/create/workflowversionlist");
              // window.location.href = "/create/workflowversionlist";
            }, 2000);
          } else {
            // swal(response.data.status.message, "", "warning");
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.publishVersion();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  AddSubTasks = (list, level) => {
    this.resetAllState();

    var temp_json_pc = [{ id: 1, parent_id: 0, task_type: 3, value: "New Parent", is_mandatory: 1 }];

    if (level == "L1") {
      this.setState({
        childsAddBank: true,
        selectionType: "subtasklevel2",
        subTaskParentId: list.task[0].task_id,
        parentListingConverted: this.convertWithIndex(temp_json_pc),
        parentListing: temp_json_pc,
      });
    } else {
      this.setState({
        childsAddBank: true,
        selectionType: "subtasklevel2",
        subTaskParentId: list.task_id,
        parentListingConverted: this.convertWithIndex(temp_json_pc),
        parentListing: temp_json_pc,
      });
    }
    return;
  };
  CreateSubTasksPCFromBank = (optiontype, is_mandatory) => {
    var data;

    if (optiontype === "MCQ") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: "",
        parent_id: this.state.subTaskParentId,
        child_type: 1,
        bank_id: Number(this.state.selectedMcqBankIdForTask),
        is_mandatory: is_mandatory === true ? 1 : 0,
      };
    } else if (optiontype === "Range") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: "",
        parent_id: this.state.subTaskParentId,
        child_type: 2,
        bank_id: Number(this.state.selectedRangeBankIdForTask),
        is_mandatory: is_mandatory === true ? 1 : 0,
      };
    } else {
      return;
    }

    if (data == undefined) {
      return;
    } else if (data.trigger_bank_id == 0) {
      return;
    }

    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/SOP/WorkflowSubParentChildCreate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message, "", "success");
            _this.resetAllState();
            _this.fetchTaskList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.CreateSubTasksPCFromBank();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  AddSubTasksPCFromBank = () => {
    var data;
    if (this.state.selectedBank === "MCQ") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: "",
        parent_id: this.state.subTaskParentId,
        child_type: 1,
        bank_id: Number(this.state.selectedMcqBankIdForTask),
        is_mandatory: this.state.isMandatryCheck === true ? 1 : 0,
      };
    } else if (this.state.selectedBank === "Range") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: "",
        parent_id: this.state.subTaskParentId,
        child_type: 2,
        bank_id: Number(this.state.selectedRangeBankIdForTask),
        is_mandatory: this.state.isMandatryCheck === true ? 1 : 0,
      };
    } else if (this.state.selectedBank === "ParentChild") {
      // data = {
      //     sid: ud.main_id,
      //     workflow_id: sessionStorage.getItem("selected_workflow"),
      //     question: "",
      //     parent_id: this.state.subTaskParentId,
      //     child_type: 3,
      //     bank_id: Number(this.state.selectedParentChildBankIdForTask),
      //     is_mandatory: this.state.isMandatryCheck === true ? 1 : 0
      // }

      var total_child = this.TotalCountTaskChild(this.state.parentListingConverted, []);

      var temp = {
        children: this.state.parentListingConverted,
      };
      var Flat_result_pc = this.processChildren(temp);

      this.validJsonInChildCreate(
        this.state.parentListingConverted,
        [],
        Flat_result_pc.length,
        [],
        this.state.parentListingConverted
      );
      return;
    }

    if (data == undefined) {
      return;
    } else if (data.trigger_bank_id == 0) {
      return;
    }

    this.addChildToTaskAPICall(data);
  };
  addChildToTaskAPICall = (data) => {
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/SOP/WorkflowSubParentChildCreate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message, "", "success");
            _this.resetAllState();
            _this.fetchTaskList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.addChildToTaskAPICall(data);
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  saveParentChildSubtask = () => {
    var data = {
      sid: ud.main_id,
      workflow_id: sessionStorage.getItem("selected_workflow"),
      question: this.state.question_pc_sub,
      parent_id: this.state.subTaskParentId,
      child_type: 3,
      bank_id: 0,
      is_mandatory: this.state.isMandatryCheck === true ? 1 : 0,
    };
    if (data == undefined) {
      return;
    } else if (data.trigger_bank_id == 0) {
      return;
    }
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/SOP/WorkflowSubParentChildCreate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message, "", "success");
            _this.resetAllState();
            _this.fetchTaskList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.saveParentChildSubtask();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };
  onChangeInputParent = (e, index) => {
    this.state.parentListing[index].value = e.target.value;
    // this.setState(this.state);
    var tempRaw = JSON.parse(JSON.stringify(this.state.parentListing));
    this.setState({ parentListingConverted: this.convertWithIndex(tempRaw) });
  };
  addAnotherParent = () => {
    this.state.parentListing.push({ task_type: 3, value: "" });
    this.setState(this.state);
  };
  removeAnotherParent = (index) => {
    if (this.state.parentListing.length === 1) {
      return;
    }
    this.state.parentListing.splice(index, 1);
    this.setState(this.state);
  };
  addAnotherChild = (data) => {
    var Lastindex = this.state.parentListing.length - 1;
    var tempData = Object.assign({ id: this.state.parentListing[Lastindex].id + 1 }, data);
    this.state.parentListing.push(tempData);
    var tempRaw = JSON.parse(JSON.stringify(this.state.parentListing));
    this.setState({ parentListingConverted: this.convertWithIndex(tempRaw) });
  };
  deleteTempChild = (node) => {
    this.state.parentListing.splice(node.index, 1);

    var tempRaw = JSON.parse(JSON.stringify(this.state.parentListing));
    this.setState({ parentListingConverted: this.convertWithIndex(tempRaw) });
  };
  handleMandatry = (node) => {
    this.state.parentListing[node.index].is_mandatory = this.state.parentListing[node.index].is_mandatory === 1 ? 0 : 1;
    // this.setState(this.state);
    var tempRaw = JSON.parse(JSON.stringify(this.state.parentListing));
    this.setState({ parentListingConverted: this.convertWithIndex(tempRaw) });
  };
  TotalCountTaskChild = (n, taskTypes) => {
    var _this = this;
    var count = 0;
    if (n.children == undefined) return true;
    if (n.children.length === 0) {
      return true;
    }
    n.children.forEach(function (c) {
      if (c.children.length === 0 && c.child_type === 3) {
        taskTypes.push(c);
      }
      var r = _this.TotalCountTaskChild(c, taskTypes);
      //if (!r) console.log(n);
      // count = count + 1
    });

    if (taskTypes.length === 0) {
      return false;
    } else {
      return true;
    }
  };
  validateTaskParentChild = () => { };
  addCsv = (e) => {
    let split_obj = e.target.files[0].name.split(".");
    if (split_obj[split_obj.length - 1] === "csv" || split_obj[split_obj.length - 1] === "CSV") {
    } else {
      this.CloseCsv();
      swal("Invalid file format.", "", "warning");
      return;
    }
    let _this = this;
    let formData = new FormData();
    formData.append("file", e.target.files[0]);
    e.target.value = "";
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
      "Content-type": "multipart/form-data",
    };
    axios
      .post(`${SERVER_IP}/workflowUploadCSV`, formData, { withCredentials: true, headers: headers })
      .then((response) => {
        if (response.data.error === false) {
          _this.setState({ uploadCsv: true, csv_data: response.data.CSVData });
        } else {
          // swal("Invalid csv format.", "", "warning")
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.addCsv(e);
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  CloseCsv = (call_Api) => {
    if (call_Api) {
      this.fetchTaskList();
    }
    this.setState({ uploadCsv: false, csv_data: [], csv_info_popup: false });
  };
  addCsvPopup = () => {
    this.setState({ csv_info_popup: !this.state.csv_info_popup });
  };
  handleLibraryImportChange = (libraryType, questionData) => {
    let stateName = "";
    if (libraryType === "MCQList") {
      stateName = "selectedMcqBankIdForTask";
    }
    if (libraryType === "RangeList") {
      stateName = "selectedRangeBankIdForTask";
    }
    if (libraryType === "ParentChildList") {
      stateName = "selectedParentChildBankIdForTask";
    }
    this.setState((prev) => ({ ...prev, [stateName]: questionData?.id }));
  };

  hanldeAddNewSubTaskInWorkflow = () => {
    const data = {
      sid: ud.main_id,
      workflow_id: sessionStorage.getItem("selected_workflow"),
      question: this.state.question_pc_bank,
      parent_id: this.state.subTaskParentId,
      child_type: 3,
      bank_id: Number(this.state.selectedParentChildBankIdForTask),
      is_mandatory: this.state.isMandatryCheck === true ? 1 : 0,
    };

    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/workflowSubTaskAdd`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message, "", "success");
            _this.resetAllState();
            _this.fetchTaskList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.hanldeAddNewSubTaskInWorkflow();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "", "warning");
      });
  };

  render() {
    const { errors } = this.state;
    const { user } = this.props;
    const { isMobile } = user;
    var TaskStructure = this.state.allTasks.map((li, index) => (
      <TaskTree
        node={li}
        children={li?.children}
        index={index}
        subTaskPlusClick={this.subTaskPlusClick}
        deleteTasks={this.deleteTasks}
        editTasks={this.editTasks}
        AddSubTasks={this.AddSubTasks}
        isMobile={isMobile}
      />
    ));
    var parentChildTree =
      this.state.selectedBank === "ParentChild"
        ? this.state.listParentChild.map((li, index) => (
          <ParentChildTree
            node={li}
            children={li.children}
            index={index}
            addParentChild={this.addParentChild}
            radioParentChildBankSelect={this.radioParentChildBankSelect}
            isMobile={isMobile}
          />
        ))
        : null;

    return (
      <div>
        <div className="xp-breadcrumbbar">
          {isMobile && <HeaderMobileSearch backBtn={true} />}
          <div className="row align-items-center justify-content-between">
            <div className="col-md-12 mb-3">
              {!isMobile ? (
                <h4>
                  <BackBtn /> Workflow Version List
                </h4>
              ) : (
                // <h4 className="xp-page-version">
                //   {JSON.parse(sessionStorage.getItem("selected_workflow_description")).title} (Version :{" "}
                //   {version_info.version})
                // </h4>
                <h4> Workflow Version List</h4>
              )}
            </div>
            {!isMobile ? (
              <>
                <div className="col-lg-8 mb-2">
                  <div className="xp-breadcrumb gradient-border m-0">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a onClick={() => this.props.history.push("/dashboard")}>
                          <i>
                            <HomeIcon />
                          </i>
                        </a>
                      </li>
                      <li className="breadcrumb-item">
                        <a onClick={() => this.props.history.push("/create/workflow")}>Workflow Management</a>
                      </li>
                      <li className="breadcrumb-item">
                        <a>Mechanical Engineering</a>
                      </li>
                      <li className="breadcrumb-item">
                        <a onClick={() => this.props.history.push("/create/workflowversionlist")}>Workflow Demo</a>
                      </li>
                      <li className="breadcrumb-item">
                        <a>Version 1</a>
                      </li>
                    </ol>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="d-flex justify-content-lg-end">
                    <h4 className="xp-page-title"> </h4>

                    {this.state.publishStatus === "publish" ? (
                      <h4 className="xp-page-title">
                        <button
                          onClick={this.publishClick}
                          type="button"
                          className="btn btn-white rounded"
                          style={{ width: "180px", padding: "12px" }}
                          data-toggle="tooltip"
                          data-placement="top"
                        >
                          <i className="fa fa-rocket"></i> Publish
                        </button>{" "}
                      </h4>
                    ) : null}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="col-lg-4">
                  <div className="dv-center ">
                    <h4 className="xp-page-title "> </h4>

                    {this.state.publishStatus === "publish" ? (
                      <h4 className="xp-page-title">
                        <button
                          onClick={this.publishClick}
                          type="button"
                          className="btn btn-white rounded schedile-btn"
                          style={{ width: "180px", padding: "12px" }}
                          data-toggle="tooltip"
                          data-placement="top"
                        >
                          <i className="fa fa-rocket"></i> Public
                        </button>{" "}
                      </h4>
                    ) : null}
                  </div>
                </div>{" "}
              </>
            )}
          </div>
        </div>

        <div className="xp-contentbar p-30 mcqtaskrange" style={{ paddingBottom: "0", marginBottom: "0" }}>
          {isMobile ? (
            <>
              {" "}
              <div className="bg-light px-3 py-2 border rounded mb-4">
                <div className="dv-center ">
                  <div className="col-lg-6">
                    <h5 className="xp-page-version">
                      {JSON.parse(sessionStorage.getItem("selected_workflow_description")).title} (Version :{" "}
                      {version_info.version})
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <div className="dv-center flex-col">
                      <button
                        onClick={this.addTask}
                        type="button"
                        style={{ width: "180px" }}
                        className="btn btn-white rounded mr-2 schedile-btn"
                      >
                        <i className="mdi mdi-plus"></i> Add Task/ Steps
                      </button>
                      <button
                        onClick={this.addCsvPopup}
                        type="button"
                        style={{ width: "180px" }}
                        className="btn btn-white rounded mr-2 schedile-btn"
                      >
                        {" "}
                        Add CSV
                      </button>
                      {/* {this.state.publishStatus === "publish" ?
                                        <h4 className="xp-page-title"><button onClick={this.publishClick} type="button" className="btn btn-success rounded" style={{ width: "180px" }} data-toggle="tooltip" data-placement="top" ><i className="fa fa-rocket"></i> Publish</button> </h4>

                                        : null} */}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {" "}
              <div className="bg-light px-3 py-2 border rounded mb-4">
                <div className="dv-center ">
                  <div className="col-lg-5">
                    <h5 className="xp-page-version">
                      {JSON.parse(sessionStorage.getItem("selected_workflow_description")).title} (Version :{" "}
                      {version_info.version})
                    </h5>
                  </div>
                  <div className="col-lg-7 d-flex justify-content-end ">
                    <div className="dv-center flex-col gap-2">
                      <button
                        onClick={this.addTask}
                        type="button"
                        style={{ width: "180px" }}
                        className="btn btn-white rounded mr-2 schedile-btn"
                      >
                        <i className="mdi mdi-plus"></i> Add Task/ Steps
                      </button>
                      <button
                        onClick={this.addCsvPopup}
                        type="button"
                        style={{ width: "180px" }}
                        className="btn btn-white rounded mr-2 schedile-btn"
                      >
                        {" "}
                        Add CSV
                      </button>
                      {/* {this.state.publishStatus === "publish" ?
                                        <h4 className="xp-page-title"><button onClick={this.publishClick} type="button" className="btn btn-success rounded" style={{ width: "180px" }} data-toggle="tooltip" data-placement="top" ><i className="fa fa-rocket"></i> Publish</button> </h4>

                                        : null} */}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="row justify-content-between">
            <div className="col-lg-12 xpcontent2">
              {this.state.publishLoader ? (
                <div className="loadingWrap">
                  <div className="loading-container">
                    <svg className="loading" viewBox="0 0 84.6 84.6">
                      <defs>
                        <filter id="stickyFilter">
                          <feGaussianBlur in="SourceGraphic" stdDeviation="2" result="blur" />
                          <feColorMatrix
                            in="blur"
                            mode="matrix"
                            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                            result="filter"
                          />
                          <feComposite in="SourceGraphic" in2="filter" operator="atop" />
                        </filter>
                        <linearGradient
                          id="gradient"
                          className="gradient"
                          x1="0%"
                          y1="0%"
                          x2="0%"
                          y2="40%"
                          gradientTransform="rotate(45)"
                        >
                          <stop offset="0%" />
                          <stop offset="100%" />
                        </linearGradient>
                      </defs>
                      <clipPath id="clip">
                        <circle cx="42.3" cy="42.3" r="41.6" />
                      </clipPath>
                      <g clip-path="url(#clip)">
                        <path className="background" d="M0 0h84.6v84.6H0z" />
                        <g className="exhaust">
                          <path
                            className="gradientBox"
                            d="M2.37244 65.5981l28.84968-28.84968 16.54614 16.54614-28.84968 28.84968z"
                          />
                          <path
                            className="gradientBox"
                            d="M6.35189 69.55189l28.84968-28.84968 8.34378 8.34378-28.84968 28.84968z"
                          />
                          <g className="filteredGroup">
                            <path className="line1 line lineThick" d="M47.7 49.6L13.4 83.9" />
                            <path className="line2 line lineThick" d="M42.3 42.3L8 76.6" />
                            <path className="line3 line lineThick" d="M33.5 38.5L-.8 72.8" />

                            <path className="line4 line lineDots" d="M45 45.82L10.7 80.12" />
                            <path className="line5 line lineDots" d="M38.16 40.06L3.86 74.36" />

                            <path className="line6 line lineStatic" d="M39.46 41.15L18.91 61.7" />
                            <path className="line7 line lineStatic" d="M43.57 43.77L23.02 64.32" />
                          </g>
                        </g>
                        <g className="rotate">
                          <g className="rumble">
                            <path
                              className="arrow"
                              d="M60.8 27.2c.6-2.1-1.3-4-3.4-3.4L19.5 35.3c-2.2.7-2.6 3.6-.8 4.9l15.8 7.6c1.1.5 2 1.4 2.5 2.6L44.4 66c1.3 1.9 4.2 1.4 4.9-.8l11.5-38z"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                    <div className="label anime-text">Publish your request...</div>
                  </div>
                </div>
              ) : null}
              <div className="sortable">
                {TaskStructure}
                {this.state.allTasks.length === 0 ? (
                  this.state.message === "" ? (
                    // loader
                    <div className="lds-spinner">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  ) : (
                    // loader-end
                    <div className="message-no-record"> {this.state.message} </div>
                  )
                ) : null}
                {this.state.publishPopup ? (
                  <div id="popup" className="overlay">
                    <div className="popup" style={{ width: "60%", margin: "10% auto" }}>
                      <div className="content">
                        <div className="card m-b-30">
                          <div className="card-header bg-white heading-cont">
                            <h5 className="card-title text-black">
                              Publish Version: <span>{version_info.version}</span>
                            </h5>
                            <button onClick={() => this.setState({ publishPopup: false })} className="close-s">
                              <CloseIcon />
                            </button>
                          </div>

                          <div className="card-body ">
                            {/* <div className="form-group">
                              <p className="cus-badge">
                                Version : <span>{version_info.version}</span>
                              </p>
                            </div> */}
                            <div className="form-group">
                              <label for="exampleInputEmail1">Description</label>
                              <input
                                type="text"
                                onChange={this.onChangeInput}
                                name="descriptionPublish"
                                className="form-control"
                                placeholder="Enter Description"
                              />
                            </div>
                            <button onClick={this.publishVersion} className="btn btn-primary mt-3">
                              <i className="fa fa-rocket"></i> Publish
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* <div className="side-drag-wrapper" id="draggablemodal"> */}
                <div className="side-drag-wrapper">
                  {this.state.selectionType != "none" ? (
                    <div>
                      {this.state.selectionType == "task" || this.state.selectionType == "subtasklevel2" ? (
                        <div
                          className="modal fade show overlaymodal"
                          style={{ display: "block", paddingRight: "5px", zIndex: "9999" }}
                          tabIndex="-1"
                          role="dialog"
                          aria-hidden="true"
                        >
                          <div
                            className="modal-dialog  modal-xl modal-dialog-centered modal-dialog-scrollable"
                            role="document"
                            style={{ width: "100%", maxWidth: "50rem" }}
                          >
                            <div className="modal-content p-3">
                              <div className="workflowbodycont border-secondary">
                                <div
                                  className="border-radious-0 pr-2 pl-3"
                                  style={{
                                    display:
                                      this.state.selectedBank === "ParentChild" &&
                                        this.state.childsAddBank == false &&
                                        this.state.selectedNodeIDForPC
                                        ? "none"
                                        : "block",
                                  }}
                                  id="headingOne"
                                >
                                  <div className="dv-center w-100 justify-content-between">
                                    <h4>Create Tasks/Steps</h4>
                                    <div>
                                      <button
                                        onClick={this.hideBankOption}
                                        className="close-s"
                                        type="button"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Close"
                                      >
                                        <CloseIcon />
                                      </button>
                                    </div>
                                  </div>

                                  {/* <div className="taskimportlib">
                                    <h6>Task Type</h6>
                                  </div> */}

                                  <div className="taskstypes">
                                    <div className="item">
                                      <input
                                        type="radio"
                                        value="MCQ"
                                        id="customRadioInline1"
                                        name="SelectBankType"
                                        onChange={this.selectedBank}
                                        checked={this.state.selectedBank === "MCQ"}
                                        className="custom-radio-hidden"
                                      />
                                      <label className="custom-radio-btn" for="customRadioInline1">
                                        MCQ
                                      </label>
                                    </div>
                                    <div className="item">
                                      <input
                                        type="radio"
                                        value="Range"
                                        id="customRadioInline2"
                                        name="SelectBankType"
                                        onChange={this.selectedBank}
                                        className="custom-radio-hidden"
                                        checked={this.state.selectedBank === "Range"}
                                      />
                                      <label className="custom-radio-btn" for="customRadioInline2">
                                        Range
                                      </label>
                                    </div>
                                    <div className="item">
                                      <input
                                        type="radio"
                                        value="ParentChild"
                                        id="customRadioInline3"
                                        name="SelectBankType"
                                        onChange={this.selectedBank}
                                        className="custom-radio-hidden"
                                        checked={this.state.selectedBank === "ParentChild"}
                                      />
                                      <label className="custom-radio-btn" for="customRadioInline3">
                                        Question Hierarchy
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div id="dragwrapper" className="collapse show" aria-labelledby="headingOne">
                                  {this.state.createBank && this.state.SelectedBankTypeForCreateBank != undefined ? (
                                    <div>
                                      {this.state.SelectedBankTypeForCreateBank === "MCQ" ? (
                                        <div>
                                          <div className="card-body addtasksteps">
                                            <div className="pr-2">
                                              <div className="form-group">
                                                <label for="exampleInputEmail1">Question</label>
                                                <input
                                                  type="text"
                                                  onChange={this.onChangeInput}
                                                  name="quectionMcq"
                                                  className="form-control"
                                                  placeholder="Enter Question"
                                                />
                                              </div>

                                              <div className="form-group option-types py-2 pl-0">
                                                <div className="custom-control">
                                                  <input
                                                    type="radio"
                                                    value="mcq"
                                                    id="customRadioInline4"
                                                    name="SelectMcqType"
                                                    onChange={this.selectedMcqType}
                                                    className="custom-control-input"
                                                  />
                                                  <label
                                                    className="custom-control-label option-label pl-1"
                                                    for="customRadioInline4"
                                                  >
                                                    4 Options
                                                  </label>
                                                </div>
                                                <div className="custom-control">
                                                  <input
                                                    type="radio"
                                                    value="yesno"
                                                    id="customRadioInline5"
                                                    name="SelectMcqType"
                                                    onChange={this.selectedMcqType}
                                                    className="custom-control-input"
                                                  />
                                                  <label
                                                    className="custom-control-label option-label pl-1"
                                                    for="customRadioInline5"
                                                  >
                                                    2 Options
                                                  </label>
                                                </div>
                                              </div>

                                              {this.state.McqTypeBank === "mcq" ? (
                                                <div className="row">
                                                  <div className="col-md-12">
                                                    <div className="form-group">
                                                      {/* <label for="exampleInputEmail1">Option 1 (Correct)</label> */}
                                                      <input
                                                        type="text"
                                                        onChange={this.onChangeInput}
                                                        name="correctAnsMcq"
                                                        value={this.state.correctAnsMcq}
                                                        className="form-control border-success"
                                                        placeholder="Correct Option 1"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="col-md-12">
                                                    <div className="form-group">
                                                      {/* <label for="exampleInputEmail1">Option 2 (Wrong)</label> */}
                                                      <input
                                                        type="text"
                                                        onChange={this.onChangeInput}
                                                        name="alt1AnsMcq"
                                                        value={this.state.alt1AnsMcq}
                                                        className="form-control"
                                                        placeholder="Option 2 (Wrong)"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="col-md-12">
                                                    <div className="form-group">
                                                      {/* <label for="exampleInputEmail1">Option 3 (Wrong)</label> */}
                                                      <input
                                                        type="text"
                                                        onChange={this.onChangeInput}
                                                        name="alt2AnsMcq"
                                                        value={this.state.alt2AnsMcq}
                                                        className="form-control"
                                                        placeholder="Option 3 (Wrong)"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="col-md-12">
                                                    <div className="form-group">
                                                      {/* <label for="exampleInputEmail1">Option 4 (Wrong)</label> */}
                                                      <input
                                                        type="text"
                                                        onChange={this.onChangeInput}
                                                        name="alt3AnsMcq"
                                                        value={this.state.alt3AnsMcq}
                                                        className="form-control"
                                                        placeholder="Option 4 (Wrong)"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="col-md-6 pt-3">
                                                    <div className="form-row">
                                                      <div className="form-group pl-2">
                                                        <label class="custom-checkbox">
                                                          {/* <input type="checkbox" /> */}
                                                          <input
                                                            type="checkbox"
                                                            className="ml-2 mr-2"
                                                            name="mcqIsMandatry"
                                                            onChange={() =>
                                                              this.setState({
                                                                mcqIsMandatry: !this.state.mcqIsMandatry,
                                                              })
                                                            }
                                                            checked={this.state.mcqIsMandatry}
                                                          />
                                                          <span class="checkmark"></span>
                                                          Is Mandatory
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="col-md-6 text-md-right pt-3">
                                                    <button
                                                      onClick={this.SaveMcqBank}
                                                      type="button"
                                                      className="btn btn-primary"
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      title="Add"
                                                    >
                                                      + Create New Question
                                                    </button>
                                                  </div>
                                                </div>
                                              ) : (
                                                ""
                                              )}

                                              {this.state.McqTypeBank === "yesno" ? (
                                                <div>
                                                  <div className="form-group">
                                                    {/* <label for="exampleInputEmail1">Option 1 (Correct)</label> */}
                                                    <input
                                                      type="text"
                                                      onChange={this.onChangeInput}
                                                      name="correctAnsMcq"
                                                      value={this.state.correctAnsMcq}
                                                      className="form-control border-success"
                                                      placeholder="Correct Option 1"
                                                    />
                                                  </div>
                                                  <div className="form-group">
                                                    {/* <label for="exampleInputEmail1">Option 2 (Wrong)</label> */}
                                                    <input
                                                      type="text"
                                                      onChange={this.onChangeInput}
                                                      name="alt1AnsMcq"
                                                      value={this.state.alt1AnsMcq}
                                                      className="form-control"
                                                      placeholder="Option 2 (Wrong)"
                                                    />
                                                  </div>
                                                  <div className="form-row align-items-center justify-content-between pt-3">
                                                    <div className="form-group ismandtry ">
                                                      <label class="custom-checkbox pl-2">
                                                        <input
                                                          type="checkbox"
                                                          className="ml-2 mr-2"
                                                          name="mcqIsMandatry"
                                                          onChange={() =>
                                                            this.setState({ mcqIsMandatry: !this.state.mcqIsMandatry })
                                                          }
                                                          checked={this.state.mcqIsMandatry}
                                                        />
                                                        <span class="checkmark"></span>
                                                        Is Mandatory
                                                      </label>
                                                    </div>
                                                    <button
                                                      onClick={this.SaveMcqBank}
                                                      type="button"
                                                      className="btn btn-primary"
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      title="Add"
                                                    >
                                                      Create New Question
                                                    </button>
                                                  </div>
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                            <ImportFromLibrary
                                              libraryType="MCQList"
                                              handleImportClick={this.addTaskFromBank}
                                              handleChange={this.handleLibraryImportChange}
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        ""
                                      )}

                                      {this.state.SelectedBankTypeForCreateBank === "Range" ? (
                                        <div>
                                          {/* <div className="card-header bg-white heading-cont">
                                            <h5 className="card-title text-black">Create Range Library</h5>
                                            <div onClick={() => this.setState({ createBank: false })}>
                                              <svg
                                                className="bi bi-x-circle-fill"
                                                width="1em"
                                                height="1em"
                                                viewBox="0 0 16 16"
                                                fill="currentColor"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  fill-rule="evenodd"
                                                  d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z"
                                                  clip-rule="evenodd"
                                                />
                                              </svg>
                                            </div>
                                          </div> */}

                                          <div className="card-body addtasksteps d-flex flex-column justify-content-between">
                                            <div className="questionslist">
                                              <div className="form-group">
                                                <label for="exampleInputEmail1">Question</label>
                                                <input
                                                  type="text"
                                                  onChange={this.onChangeInput}
                                                  name="quectionRange"
                                                  className="form-control"
                                                  placeholder="Question"
                                                />
                                              </div>
                                              <div className="form-group pt-3">
                                                <input
                                                  type="number"
                                                  onChange={this.onChangeInput}
                                                  name="minRange"
                                                  className="form-control"
                                                  placeholder="Minimum Value"
                                                />
                                              </div>
                                              <div className="form-group">
                                                <input
                                                  type="number"
                                                  onChange={this.onChangeInput}
                                                  name="maxRange"
                                                  className="form-control"
                                                  placeholder="Maximum Value"
                                                />
                                              </div>
                                            </div>
                                            <div className="form-row justify-content-between align-items-center pt-3">
                                              <div className="form-group pl-2">
                                                <label class="custom-checkbox">
                                                  <input
                                                    type="checkbox"
                                                    className="ml-2 mr-2"
                                                    name="rangeIsMandatry"
                                                    onChange={() =>
                                                      this.setState({ rangeIsMandatry: !this.state.rangeIsMandatry })
                                                    }
                                                    checked={this.state.rangeIsMandatry}
                                                  />
                                                  <span class="checkmark"></span>
                                                  Is Mandatory
                                                </label>
                                              </div>
                                              <button
                                                onClick={this.SaveRangeBank}
                                                type="button"
                                                className="btn btn-primary"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Add"
                                              >
                                                Create New Question
                                              </button>
                                            </div>
                                            <ImportFromLibrary
                                              libraryType="RangeList"
                                              handleImportClick={this.addTaskFromBank}
                                              handleChange={this.handleLibraryImportChange}
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        ""
                                      )}

                                      {this.state.SelectedBankTypeForCreateBank === "ParentChild" ? (
                                        <div>
                                          {/* <div className="questionnaire"> */}
                                          <div className="py-4 addtasksteps ">
                                            {/* <div className="pr-2 pl-3 dv-center" noradius="zero">
                                              <div className="mt-2">
                                                <h4> </h4>
                                                <div className="custom-control custom-radio custom-control-inline"></div>
                                              </div>
                                            </div> */}
                                            {/* <button
                                              onClick={() => this.setState({ createBank: false, question_pc_bank: "" })}
                                              type="button"
                                              className="btn btn-round btn-danger close-q"
                                            >
                                              <i className="mdi mdi-close"></i>
                                            </button> */}

                                            {/* <div className="stp1"> */}
                                            <div className="px-2">
                                              <label>Add Question Hierarchy</label>
                                              <div className="form-content text-center">
                                                <input
                                                  type="text"
                                                  onChange={this.onChangeInput}
                                                  className="form-control"
                                                  name="question_pc_bank"
                                                  id="inputText"
                                                  placeholder="Question..."
                                                />
                                                <button
                                                  onClick={
                                                    this.state.selectionType == "subtasklevel2"
                                                      ? this.hanldeAddNewSubTaskInWorkflow
                                                      : this.saveParentChildBankForP
                                                  }
                                                  type="button"
                                                  className="btn btn-primary mt-3"
                                                >
                                                  <i className="mdi mdi-plus mr-2"></i> Create New Question
                                                </button>
                                              </div>
                                            </div>
                                          </div>

                                          <ImportFromLibrary
                                            libraryType="ParentChildList"
                                            handleImportClick={
                                              this.state.selectionType == "subtasklevel2"
                                                ? this.hanldeAddNewSubTaskInWorkflow
                                                : this.addTaskFromBank
                                            }
                                            handleChange={this.handleLibraryImportChange}
                                          />
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  ) : (
                                    <div className="card-body pos-rel">
                                      <div className="stick-up">
                                        {
                                          this.state.childsAddBank && this.state.selectedBank === "ParentChild"
                                            ? null
                                            : ""
                                          // <div className="filter-form">
                                          //     <input type="text" className="form-control" name="inputText" id="inputText" placeholder="Filter Search" />
                                          //     <input type="text" className="form-control" name="inputText" id="inputText" placeholder="Filter Search" />
                                          //     <select className="form-control">
                                          //         <option>Item</option>
                                          //         <option>Item</option>
                                          //         <option>Item</option>
                                          //         <option>Item</option>
                                          //         <option>Item</option>
                                          //     </select>
                                          // </div>
                                        }
                                        <div className="pull-right mt-2">
                                          {this.state.childsAddBank &&
                                            this.state.selectedBank === "ParentChild" ? null : (
                                            <>
                                              {/* <button
                                               type="button"
                                               onClick={this.createBank}
                                               className="btn btn-primary ml-2"
                                             >
                                               <i className="mdi mdi-plus"></i> Create
                                             </button> */}
                                            </>
                                          )}
                                          <button
                                            type="button"
                                            onClick={this.addTaskFromBank}
                                            className="btn btn-primary ml-2"
                                          >
                                            <i className="mdi mdi-plus"></i> Add To Workflow
                                          </button>
                                        </div>
                                        <div className="clearfix"></div>
                                      </div>
                                      {this.state.childsAddBank && this.state.selectedBank === "ParentChild" ? null : (
                                        <div className="form-row mt-3">
                                          <div className="form-group ismandtry">
                                            <input
                                              id="c1"
                                              className="ml-2 mr-2"
                                              type="checkbox"
                                              onChange={() =>
                                                this.setState({ isMandatryCheck: !this.state.isMandatryCheck })
                                              }
                                              checked={this.state.isMandatryCheck}
                                            />
                                            {/* <label className="mb-0" for="c1">&nbsp;  */}
                                            Is Mandatory
                                            {/* </label> */}
                                          </div>
                                        </div>
                                      )}

                                      {this.state.selectedBank === "MCQ" ? (
                                        <div className="mt-2 sticky-fixed">
                                          {this.state.mcqBankList.map((list, index) => (
                                            <div className="item">
                                              <div className="custom-control custom-radio">
                                                <input
                                                  type="radio"
                                                  id={`customRadio${index + 10}`}
                                                  value={list.id}
                                                  onChange={this.radioMcqBankSelect}
                                                  name="mcqBankRadio"
                                                  className="custom-control-input"
                                                />
                                                <label
                                                  className="custom-control-label"
                                                  for={`customRadio${index + 10}`}
                                                >
                                                  {list.question}
                                                </label>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      ) : null}

                                      {this.state.selectedBank === "Range" ? (
                                        <div className="mt-2 sticky-fixed">
                                          {this.state.rangeBankList.map((list, index) => (
                                            <div className="item">
                                              <div className="custom-control custom-radio">
                                                <input
                                                  type="radio"
                                                  id={`customRadio${index + 10}`}
                                                  value={list.id}
                                                  onChange={this.radioRangeBankSelect}
                                                  name="rangeBankRadio"
                                                  className="custom-control-input"
                                                />
                                                <label
                                                  className="custom-control-label"
                                                  for={`customRadio${index + 10}`}
                                                >
                                                  {list.question}
                                                </label>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      ) : null}

                                      {this.state.selectedBank === "ParentChild" ? (
                                        <div>
                                          {this.state.childsAddBank ? (
                                            <div className="mt-2 sticky-fixed">
                                              {this.state.parentListingConverted.map((li, ind) => (
                                                <ParentChildTreeForAddChildsToParent
                                                  node={li}
                                                  children={li.children}
                                                  onChangeInputParent={this.onChangeInputParent}
                                                  fetchMcqBankList={this.fetchMcqBankList}
                                                  fetchRangeBankList={this.fetchRangeBankList}
                                                  mcqBankList={this.state.mcqBankList}
                                                  rangeBankList={this.state.rangeBankList}
                                                  addAnotherChild={this.addAnotherChild}
                                                  deleteTempChild={this.deleteTempChild}
                                                  handleMandatry={this.handleMandatry}
                                                />
                                              ))}

                                              {/* {this.state.parentListing.map((li, ind) =>
                                                                                    <div >
                                                                                        <div className="custom-control form-content text-center" style={{ display: "flex" }}>
                                                                                            <input type="text" onChange={(e) => this.onChangeInputParent(e, ind)} className="form-control" name="question_pc_sub" value={this.state.parentListing[ind].value} id="inputText" placeholder="Parent..." />
                                                                                            {ind === 0 ? <button onClick={this.addAnotherParent} type="button" className="btn btn-primary"> <i className="fa fa-plus-circle" aria-hidden="true"></i></button> : null}
                                                                                            <button onClick={() => this.removeAnotherParent(ind)} type="button" className="btn btn-primary"> <i className="fa fa-minus-circle" aria-hidden="true"></i></button>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                                <div className="form-row">
                                                                                    <div className="form-group col-md-6">
                                                                                        <h4>Select MCQ, Range Or Parent</h4>
                                                                                    </div>
                                                                                    <div className="form-group col-md-6">
                                                                                        <div className="custom-control custom-radio custom-control-inline">
                                                                                            <input type="radio" value="MCQ" id="customRadioInline4" name="SelectMcqType" onChange={this.selectedMcqOrRangePC} className="custom-control-input" checked={this.state.SelectedMcqOrRangePC ==="MCQ"} />
                                                                                            <label className="custom-control-label" for="customRadioInline4">MCQ</label>
                                                                                        </div>
                                                                                        <div className="custom-control custom-radio custom-control-inline">
                                                                                            <input type="radio" value="Range" id="customRadioInline5" name="SelectMcqType" onChange={this.selectedMcqOrRangePC} className="custom-control-input" checked={this.state.SelectedMcqOrRangePC==="Range"}/>
                                                                                            <label className="custom-control-label" for="customRadioInline5">Range</label>
                                                                                        </div>
                                                                                        <div className="custom-control custom-radio custom-control-inline">
                                                                                            <input type="radio" value="Parent" id="customRadioInline5" name="SelectMcqType" onChange={this.selectedMcqOrRangePC} className="custom-control-input" checked={this.state.SelectedMcqOrRangePC==="Parent"}/>
                                                                                            <label className="custom-control-label" for="customRadioInline5">Parent</label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                {this.state.SelectedMcqOrRangePC === "MCQ" ?
                                                                                    <div className="mt-2 sticky-fixed">
                                                                                        {this.state.mcqBankList.map((list, index) =>
                                                                                            <div className="item">
                                                                                                <div className="custom-control custom-radio">
                                                                                                    <input type="radio" id={`customRadio${index + 10}`} value={list.id} onChange={this.radioMcqBankSelectChild} name="mcqBankRadio" className="custom-control-input" />
                                                                                                    <label className="custom-control-label" for={`customRadio${index + 10}`}>{list.question}</label>
                                                                                                </div>

                                                                                            </div>
                                                                                        )}

                                                                                    </div>
                                                                                    : null}
                                                                                {this.state.SelectedMcqOrRangePC === "Range" ?
                                                                                    <div className="mt-2 sticky-fixed">
                                                                                        {this.state.rangeBankList.map((list, index) =>
                                                                                            <div className="item">
                                                                                                <div className="custom-control custom-radio">
                                                                                                    <input type="radio" id={`customRadio${index + 10}`} value={list.id} onChange={this.radioRangeBankSelectChild} name="rangeBankRadio" className="custom-control-input" />
                                                                                                    <label className="custom-control-label" for={`customRadio${index + 10}`}>{list.question}</label>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}

                                                                                    </div>
                                                                                    : null} */}
                                            </div>
                                          ) : (
                                            <div className="mt-2 sticky-fixed pr-2">
                                              {parentChildTree}
                                              {this.state.selectedNodeIDForPC ? (
                                                <div>
                                                  <div className="questionnaire stp2questions">
                                                    <div className="card-header dv-center w-100 mb-3" noradius="zero">
                                                      <div className="mt-2 w-100">
                                                        <div className="d-flex align-items-center w-100 justify-content-between  pb-2">
                                                          <h4 className="mb-0">Add Question Hierarchy</h4>
                                                          <button
                                                            onClick={() =>
                                                              this.setState({
                                                                selectedRangeBankIdForTask: "",
                                                                selectedMcqBankIdForTask: "",
                                                                p_c_question_type: null,
                                                                selectedNodeIDForPC: undefined,
                                                              })
                                                            }
                                                            type="button"
                                                            className="close-s"
                                                          >
                                                            <CloseIcon />
                                                          </button>
                                                        </div>

                                                        <div className="custom-control custom-radio custom-control-inline">
                                                          <input
                                                            type="radio"
                                                            id="in-1"
                                                            value="1"
                                                            onChange={this.onChangeInputCreateParent}
                                                            name="p_c_question_type"
                                                            className="custom-control-input"
                                                          />
                                                          <label className="custom-control-label" for="in-1">
                                                            MCQ
                                                          </label>
                                                        </div>
                                                        <div className="custom-control custom-radio custom-control-inline">
                                                          <input
                                                            type="radio"
                                                            id="in-2"
                                                            value="2"
                                                            onChange={this.onChangeInputCreateParent}
                                                            name="p_c_question_type"
                                                            className="custom-control-input"
                                                          />
                                                          <label className="custom-control-label" for="in-2">
                                                            Range
                                                          </label>
                                                        </div>
                                                        <div className="custom-control custom-radio custom-control-inline">
                                                          <input
                                                            type="radio"
                                                            id="in-3"
                                                            value="3"
                                                            onChange={this.onChangeInputCreateParent}
                                                            name="p_c_question_type"
                                                            className="custom-control-input"
                                                          />
                                                          <label className="custom-control-label" for="in-3">
                                                            Question Hierarchy
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="stp1">
                                                      {!this.state.p_c_question_type && (
                                                        <p className="choosehirachy">Please choose an option</p>
                                                      )}
                                                      {this.state.p_c_question_type == 1 ? (
                                                        <div className="w-100">
                                                          {this.state.createBankMcqOnP_C ? (
                                                            // <div pc="innerchild">
                                                            <div>
                                                              <div className="parent-list-cont">
                                                                <div className="card-header bg-white heading-cont pt-0">
                                                                  <h5 className="card-title text-black">
                                                                    Create MCQ Library
                                                                  </h5>
                                                                  <div
                                                                    onClick={() =>
                                                                      this.setState({
                                                                        createBankMcqOnP_C: false,
                                                                        quectionMcq: "",
                                                                        correctAnsMcq: "",
                                                                        alt1AnsMcq: "",
                                                                        alt2AnsMcq: "",
                                                                        alt3AnsMcq: "",
                                                                        mcqIsMandatry: false,
                                                                        McqTypeBank: "",
                                                                      })
                                                                    }
                                                                  >
                                                                    <svg
                                                                      className="bi bi-x-circle-fill"
                                                                      width="1em"
                                                                      height="1em"
                                                                      viewBox="0 0 16 16"
                                                                      fill="currentColor"
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                      <path
                                                                        fill-rule="evenodd"
                                                                        d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z"
                                                                        clip-rule="evenodd"
                                                                      />
                                                                    </svg>
                                                                  </div>
                                                                </div>

                                                                <div className="card-body mcqcreatehir">
                                                                  <div className="form-row">
                                                                    <div className="form-group col-md-6">
                                                                      <h5>MCQ Type :</h5>
                                                                    </div>
                                                                    <div className="custom-control custom-radio custom-control-inline">
                                                                      <input
                                                                        type="radio"
                                                                        value="mcq"
                                                                        id="customRadioInline4"
                                                                        name="SelectMcqType"
                                                                        onChange={this.selectedMcqType}
                                                                        className="custom-control-input"
                                                                      />
                                                                      <label
                                                                        className="custom-control-label"
                                                                        for="customRadioInline4"
                                                                      >
                                                                        4 Options
                                                                      </label>
                                                                    </div>
                                                                    <div className="custom-control custom-radio custom-control-inline">
                                                                      <input
                                                                        type="radio"
                                                                        value="yesno"
                                                                        id="customRadioInline5"
                                                                        name="SelectMcqType"
                                                                        onChange={this.selectedMcqType}
                                                                        className="custom-control-input"
                                                                      />
                                                                      <label
                                                                        className="custom-control-label"
                                                                        for="customRadioInline5"
                                                                      >
                                                                        2 Options
                                                                      </label>
                                                                    </div>
                                                                  </div>
                                                                  <div className="form-group">
                                                                    <label for="exampleInputEmail1">
                                                                      Question / Step
                                                                    </label>
                                                                    <input
                                                                      type="text"
                                                                      onChange={this.onChangeInput}
                                                                      name="quectionMcq"
                                                                      className="form-control"
                                                                      placeholder="Enter Question"
                                                                    />
                                                                  </div>

                                                                  {this.state.McqTypeBank === "mcq" ? (
                                                                    <div className="questionsmcq">
                                                                      <div className="form-group">
                                                                        <label for="exampleInputEmail1">
                                                                          Option 1 (Correct)
                                                                        </label>
                                                                        <input
                                                                          type="text"
                                                                          onChange={this.onChangeInput}
                                                                          name="correctAnsMcq"
                                                                          value={this.state.correctAnsMcq}
                                                                          className="form-control"
                                                                          placeholder="Enter Option 1"
                                                                        />
                                                                      </div>
                                                                      <div className="form-group">
                                                                        <label for="exampleInputEmail1">
                                                                          Option 2 (Wrong)
                                                                        </label>
                                                                        <input
                                                                          type="text"
                                                                          onChange={this.onChangeInput}
                                                                          name="alt1AnsMcq"
                                                                          value={this.state.alt1AnsMcq}
                                                                          className="form-control"
                                                                          placeholder="Enter Option 2"
                                                                        />
                                                                      </div>
                                                                      <div className="form-group">
                                                                        <label for="exampleInputEmail1">
                                                                          Option 3 (Wrong)
                                                                        </label>
                                                                        <input
                                                                          type="text"
                                                                          onChange={this.onChangeInput}
                                                                          name="alt2AnsMcq"
                                                                          value={this.state.alt2AnsMcq}
                                                                          className="form-control"
                                                                          placeholder="Enter Option 3"
                                                                        />
                                                                      </div>
                                                                      <div className="form-group">
                                                                        <label for="exampleInputEmail1">
                                                                          Option 4 (Wrong)
                                                                        </label>
                                                                        <input
                                                                          type="text"
                                                                          onChange={this.onChangeInput}
                                                                          name="alt3AnsMcq"
                                                                          value={this.state.alt3AnsMcq}
                                                                          className="form-control"
                                                                          placeholder="Enter Option 4"
                                                                        />
                                                                      </div>
                                                                      <div className="form-row w-100 justify-content-between">
                                                                        <div className="form-group">
                                                                          <input
                                                                            type="checkbox"
                                                                            className="ml-2 mr-2"
                                                                            name="mcqIsMandatry"
                                                                            onChange={() =>
                                                                              this.setState({
                                                                                mcqIsMandatry:
                                                                                  !this.state.mcqIsMandatry,
                                                                              })
                                                                            }
                                                                            checked={this.state.mcqIsMandatry}
                                                                          />
                                                                          Is Mandatory
                                                                        </div>
                                                                        <button
                                                                          onClick={this.saveMcqBankDataOnPC}
                                                                          type="button"
                                                                          className="btn btn-primary save-btn"
                                                                          data-toggle="tooltip"
                                                                          data-placement="top"
                                                                          title="Add"
                                                                        >
                                                                          Save
                                                                        </button>
                                                                      </div>

                                                                    </div>
                                                                  ) : (
                                                                    ""
                                                                  )}

                                                                  {this.state.McqTypeBank === "yesno" ? (
                                                                    <div>
                                                                      <div className="form-group">
                                                                        <label for="exampleInputEmail1">
                                                                          Option 1 (Correct)
                                                                        </label>
                                                                        <input
                                                                          type="text"
                                                                          onChange={this.onChangeInput}
                                                                          name="correctAnsMcq"
                                                                          value={this.state.correctAnsMcq}
                                                                          className="form-control"
                                                                          placeholder="Enter Option 1"
                                                                        />
                                                                      </div>
                                                                      <div className="form-group">
                                                                        <label for="exampleInputEmail1">
                                                                          Option 2 (Wrong){" "}
                                                                        </label>
                                                                        <input
                                                                          type="text"
                                                                          onChange={this.onChangeInput}
                                                                          name="alt1AnsMcq"
                                                                          value={this.state.alt1AnsMcq}
                                                                          className="form-control"
                                                                          placeholder="Enter Option 2"
                                                                        />
                                                                      </div>
                                                                      <div className="form-row w-100 align-items-center justify-content-between">
                                                                        <div>
                                                                          <input
                                                                            id="check3"
                                                                            className="ml-2 mr-2"
                                                                            type="checkbox"
                                                                            name="mcqIsMandatry"
                                                                            checked={this.state.mcqIsMandatry}
                                                                            onChange={() =>
                                                                              this.setState({
                                                                                mcqIsMandatry:
                                                                                  !this.state.mcqIsMandatry,
                                                                              })
                                                                            }
                                                                          />
                                                                          Is Mandatory
                                                                        </div>
                                                                        <button
                                                                          onClick={this.saveMcqBankDataOnPC}
                                                                          className="btn btn-primary save-btn"
                                                                          data-toggle="tooltip"
                                                                          data-placement="top"
                                                                          title="Add"
                                                                        >
                                                                          Save
                                                                        </button>
                                                                      </div>
                                                                    </div>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          ) : (
                                                            <>
                                                              <h5>Select from MCQ List</h5>
                                                              <div className="mt-2 parent-list-wrapper">
                                                                <div className="parent-list-cont">
                                                                  {this.state.mcqBankList.map((list, index) => (
                                                                    <div className="item">
                                                                      <div className="custom-control custom-radio">
                                                                        <input
                                                                          type="radio"
                                                                          id={`customRadio${index + 10}`}
                                                                          value={list.id}
                                                                          onChange={this.radioMcqBankSelect}
                                                                          name="mcqBankRadio"
                                                                          className="custom-control-input"
                                                                        />
                                                                        <label
                                                                          className="custom-control-label"
                                                                          for={`customRadio${index + 10}`}
                                                                        >
                                                                          {list.question}
                                                                        </label>
                                                                      </div>
                                                                    </div>
                                                                  ))}
                                                                </div>
                                                                <div
                                                                  className="dv-center justify-content-between"
                                                                  style={{
                                                                    padding: "10px",
                                                                    position: "sticky",
                                                                    top: "0",
                                                                    background: "white",
                                                                    zIndex: "99999",
                                                                  }}
                                                                >
                                                                  <div className="form-row">
                                                                    <div>
                                                                      <input
                                                                        id="check4"
                                                                        className="ml-2 mr-2"
                                                                        type="checkbox"
                                                                        name="rangeIsMandatryP_C"
                                                                        checked={this.state.rangeIsMandatryP_C}
                                                                        onChange={() =>
                                                                          this.setState({
                                                                            rangeIsMandatryP_C:
                                                                              !this.state.rangeIsMandatryP_C,
                                                                          })
                                                                        }
                                                                      />
                                                                      {/* <label for="check4" className="ml-2"> */}
                                                                      Is Mandatory
                                                                      {/* </label> */}
                                                                    </div>

                                                                    {/* <div className="form-group col-md-2">
                                                                                                                            <input type="checkbox" name="rangeIsMandatryP_C" onChange={this.handleCheckbox} checked={this.state.rangeIsMandatryP_C} />
                                                                                                                        </div>
                                                                                                                        <div className="form-group col-md-6">
                                                                                                                            Is Mandatory
                                                                                                                        </div> */}
                                                                  </div>
                                                                  <div className="dv-center">
                                                                    <button
                                                                      onClick={() => this.saveParentChildBankForC(1)}
                                                                      type="button"
                                                                      className="btn btn-primary mr-2"
                                                                    >
                                                                      <i className="mdi mdi-plus mr-2"></i> Save
                                                                    </button>
                                                                    <button
                                                                      onClick={() =>
                                                                        this.setState({ createBankMcqOnP_C: true })
                                                                      }
                                                                      type="button"
                                                                      className="btn btn-primary mr-2"
                                                                    >
                                                                      <i className="mdi mdi-plus mr-2"></i> Create New
                                                                    </button>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </>
                                                          )}
                                                        </div>
                                                      ) : null}
                                                      {this.state.p_c_question_type == 2 ? (
                                                        <div className="w-100">
                                                          {this.state.createBankRangeOnP_C ? (
                                                            // <div pc="innerchild">
                                                            <div>
                                                              <div className="parent-list-cont mt-2">
                                                                <div className="card-header bg-white heading-cont">
                                                                  <h5 className="card-title text-black">
                                                                    Create Range Library
                                                                  </h5>
                                                                  <div
                                                                    onClick={() =>
                                                                      this.setState({
                                                                        createBankRangeOnP_C: false,
                                                                        quectionRange: "",
                                                                        max_value: "",
                                                                        min_value: "",
                                                                        is_mandatory: "",
                                                                      })
                                                                    }
                                                                  >
                                                                    <svg
                                                                      className="bi bi-x-circle-fill"
                                                                      width="1em"
                                                                      height="1em"
                                                                      viewBox="0 0 16 16"
                                                                      fill="currentColor"
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                      <path
                                                                        fill-rule="evenodd"
                                                                        d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z"
                                                                        clip-rule="evenodd"
                                                                      />
                                                                    </svg>
                                                                  </div>
                                                                </div>

                                                                <div className="card-body">
                                                                  <div className="form-group">
                                                                    <label for="exampleInputEmail1">
                                                                      Question <span>{`6`}</span>
                                                                    </label>
                                                                    <input
                                                                      type="text"
                                                                      onChange={this.onChangeInput}
                                                                      name="quectionRange"
                                                                      className="form-control"
                                                                      placeholder="Enter Question"
                                                                    />
                                                                  </div>
                                                                  <div className="form-group">
                                                                    <label for="exampleInputEmail1">
                                                                      Minimum Value
                                                                    </label>
                                                                    <input
                                                                      type="number"
                                                                      onChange={this.onChangeInput}
                                                                      name="minRange"
                                                                      className="form-control"
                                                                      placeholder="Enter Minimum Value"
                                                                    />
                                                                  </div>
                                                                  <div className="form-group">
                                                                    <label for="exampleInputEmail1">
                                                                      Maximum Value
                                                                    </label>
                                                                    <input
                                                                      type="number"
                                                                      onChange={this.onChangeInput}
                                                                      name="maxRange"
                                                                      className="form-control"
                                                                      placeholder="Enter Maximum Value"
                                                                    />
                                                                  </div>
                                                                  <div className="form-row justify-content-between align-items-center">
                                                                    <div className="form-group">
                                                                      <input
                                                                        type="checkbox"
                                                                        className="ml-2 mr-2"
                                                                        name="rangeIsMandatry"
                                                                        onChange={() =>
                                                                          this.setState({
                                                                            rangeIsMandatry:
                                                                              !this.state.rangeIsMandatry,
                                                                          })
                                                                        }
                                                                        checked={this.state.rangeIsMandatry}
                                                                      />
                                                                      Is Mandatory
                                                                    </div>
                                                                    <button
                                                                      onClick={this.saveRangeBankDataOnPC}
                                                                      type="button"
                                                                      className="btn btn-primary save-btn"
                                                                      data-toggle="tooltip"
                                                                      data-placement="top"
                                                                      title="Add"
                                                                    >
                                                                      Save
                                                                    </button>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          ) : (
                                                            <>
                                                              <h5>Select from Range List</h5>

                                                              <div className="mt-2 parent-list-wrapper">
                                                                <div className="parent-list-cont">
                                                                  {this.state.rangeBankList.map((list, index) => (
                                                                    <div className="item">
                                                                      <div className="custom-control custom-radio">
                                                                        <input
                                                                          type="radio"
                                                                          id={`customRadio${index + 10}`}
                                                                          value={list.id}
                                                                          onChange={this.radioRangeBankSelect}
                                                                          name="rangeBankRadio"
                                                                          className="custom-control-input"
                                                                        />
                                                                        <label
                                                                          className="custom-control-label"
                                                                          for={`customRadio${index + 10}`}
                                                                        >
                                                                          {list.question}
                                                                        </label>
                                                                      </div>
                                                                    </div>
                                                                  ))}
                                                                </div>
                                                                <div
                                                                  className="dv-center justify-content-between"
                                                                  style={{
                                                                    padding: "10px",
                                                                    position: "sticky",
                                                                    top: "0",
                                                                    background: "white",
                                                                    zIndex: "99999",
                                                                  }}
                                                                >
                                                                  <div className="form-row">
                                                                    <div>
                                                                      <input
                                                                        id="check5"
                                                                        type="checkbox"
                                                                        className="ml-2 mr-2"
                                                                        name="rangeIsMandatryP_C"
                                                                        checked={this.state.rangeIsMandatryP_C}
                                                                        onChange={() =>
                                                                          this.setState({
                                                                            rangeIsMandatryP_C:
                                                                              !this.state.rangeIsMandatryP_C,
                                                                          })
                                                                        }
                                                                      />
                                                                      <label for="check5" className="ml-2">
                                                                        Is Mandatory
                                                                      </label>
                                                                    </div>
                                                                    {/* <div className="form-group col-md-2">
                                                                                                                            <input type="checkbox" name="rangeIsMandatryP_C" onChange={this.handleCheckbox} checked={this.state.rangeIsMandatryP_C} />
                                                                                                                        </div>
                                                                                                                        <div className="form-group col-md-6">
                                                                                                                            Is Mandatory
                                                                                                                </div> */}
                                                                  </div>
                                                                  <div className=" dv-center">
                                                                    <button
                                                                      onClick={() => this.saveParentChildBankForC(2)}
                                                                      type="button"
                                                                      className="btn btn-primary btn-1"
                                                                    >
                                                                      <i className="mdi mdi-plus mr-2 "></i> Save
                                                                    </button>
                                                                    <button
                                                                      onClick={() =>
                                                                        this.setState({ createBankRangeOnP_C: true })
                                                                      }
                                                                      type="button"
                                                                      className="btn btn-primary ml-2 btn-2"
                                                                    >
                                                                      <i className="mdi mdi-plus mr-2"></i> Create New
                                                                    </button>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </>
                                                          )}
                                                        </div>
                                                      ) : null}
                                                      {this.state.p_c_question_type == 3 ? (
                                                        <div className="addsubhirarchy">
                                                          <div className="form-content text-center mb-3">
                                                            <input
                                                              type="text"
                                                              onChange={this.onChangeInput}
                                                              className="form-control"
                                                              name="question_pc_bank"
                                                              id="inputText"
                                                              placeholder="Question..."
                                                            />
                                                            <div className="ismanadd">
                                                              <div>
                                                                <input
                                                                  id="check5"
                                                                  type="checkbox"
                                                                  className="ml-2 mr-2"
                                                                  name="rangeIsMandatryP_C"
                                                                  checked={this.state.rangeIsMandatryP_C}
                                                                  onChange={() =>
                                                                    this.setState({
                                                                      rangeIsMandatryP_C:
                                                                        !this.state.rangeIsMandatryP_C,
                                                                    })
                                                                  }
                                                                />
                                                                <label for="check5">Is Mandatory</label>
                                                              </div>
                                                              <button
                                                                onClick={() => this.saveParentChildBankForC(3)}
                                                                type="button"
                                                                className="btn btn-primary mt-3"
                                                              >
                                                                <i className="mdi mdi-plus mr-2"></i> Create New
                                                              </button>
                                                            </div>
                                                          </div>
                                                          <ImportFromLibrary
                                                            libraryType="ParentChildList"
                                                            handleImportClick={(calledFromImportLibrary) =>
                                                              this.saveParentChildBankForC(3, calledFromImportLibrary)
                                                            }
                                                            handleChange={this.handleLibraryImportChange}
                                                          />
                                                        </div>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                            </div>
                                          )}
                                        </div>
                                      ) : null}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.selectionType == "subtask" ? (
                        <div
                          className="modal fade show overlaymodal"
                          style={{ display: "block", paddingRight: "5px", zIndex: "9999" }}
                          tabIndex="-1"
                          role="dialog"
                          aria-hidden="true"
                        >
                          <div
                            className="modal-dialog  modal-xl modal-dialog-centered modal-dialog-scrollable"
                            role="document"
                            style={{ width: "100%", maxWidth: "50rem" }}
                          >
                            <div className="modal-content p-4">
                              <div className="">
                                <div className="subtask-cont">
                                  {this.state.subtask_type == "none" ? (
                                    <div className="questionnaire">
                                      <div className="d-flex justify-content-between pr-2">
                                        <div className="t-header">
                                          <h2>Library </h2>
                                        </div>
                                        <button
                                          onClick={() => this.setState({ selectionType: "none", subtask_type: "none" })}
                                          type="button"
                                          className="close-s"
                                        >
                                          <CloseIcon />
                                        </button>
                                      </div>
                                      <div className="stp1">
                                        <div className="mt-2">
                                          {/* <button className="btn btn-primary mt-3" onClick={() => this.setState({ subtask_type: "next" })}>Proceed To Next Task</button> */}
                                          <button
                                            className="btn btn-primary btn-block mt-3 ml-2"
                                            onClick={() =>
                                              this.setState({ subtask_type: "none", selectionType: "subtasklevel2" })
                                            }
                                          >
                                            Add Sub Task
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {this.state.subtask_type == "next" ? (
                                    <div className="questionnaire">
                                      <div className="t-header bg-dark">
                                        <h2 className="text-light">Library </h2>
                                        {/* <p className="text-light">gukjbjbkjvkjvkjvkjb</p> */}
                                      </div>
                                      <button
                                        onClick={() => this.setState({ selectionType: "none", subtask_type: "none" })}
                                        type="button"
                                        className="close-s"
                                      >
                                        <CloseIcon />
                                      </button>
                                      <div className="t_height">
                                        <div className="mt-2 sticky-fixed">
                                          {this.state.tasksListForTrigger.map((list, index) => (
                                            <div className="item">
                                              <div className="custom-control custom-radio">
                                                <input
                                                  type="radio"
                                                  id={`customRadiobtn${index + 10}`}
                                                  value={list.task_id}
                                                  onChange={this.radioTaskLevel2}
                                                  name="mcqBankRadio"
                                                  className="custom-control-input"
                                                />
                                                <label
                                                  className="custom-control-label"
                                                  for={`customRadiobtn${index + 10}`}
                                                >
                                                  {list.task[0].question}
                                                </label>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>

                                      <div className="b-foot">
                                        <div>
                                          <input
                                            id="check2"
                                            type="checkbox"
                                            checked={this.state.isMandatryCheckL2}
                                            onChange={() =>
                                              this.setState({ isMandatryCheckL2: !this.state.isMandatryCheckL2 })
                                            }
                                          />
                                          <label for="check2" className="ml-2">
                                            Is Mandatory
                                          </label>
                                        </div>
                                        <button className="btn btn-primary mt-3" onClick={this.SaveTaskLavel2}>
                                          Done
                                        </button>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {this.state.editMode == 1 ? (
                    <div
                      className="modal fade show overlaymodal"
                      style={{ display: "block", paddingRight: "5px", zIndex: "9999" }}
                      tabIndex="-1"
                      role="dialog"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog  modal-xl modal-dialog-centered modal-dialog-scrollable"
                        role="document"
                        style={{ width: "65rem", maxWidth: "75rem" }}
                      >
                        <div className="modal-content">
                          <div className="border-secondary">
                            <div className="justify-content-between modal-header" id="headingOne">
                              <div className="mt-2 top-cont-edit">
                                <h4 className="modal-title">Update</h4>
                              </div>
                              <button
                                onClick={this.closeEditContainer}
                                type="button"
                                className="close-s"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Close"
                              >
                                <CloseIcon />
                              </button>
                            </div>
                          </div>
                          <div className="form-row align-items-center mt-2 pl-4">
                            <h5 className="text-dark pr-4 pb-2">MCQ Type :</h5>
                            <div className="custom-control custom-radio custom-control-inline">
                              <input
                                type="radio"
                                value="1"
                                id="customRadioInline4"
                                name="SelectMcqType"
                                onChange={this.selectedEdit}
                                className="custom-control-input"
                                checked={this.state.McqTypeBankEdit == 1 ? true : false}
                              />
                              <label className="custom-control-label" for="customRadioInline4">
                                4 Options
                              </label>
                            </div>
                            <div className="custom-control custom-radio custom-control-inline">
                              <input
                                type="radio"
                                value="2"
                                id="customRadioInline5"
                                name="SelectMcqType"
                                onChange={this.selectedEdit}
                                className="custom-control-input"
                                checked={this.state.McqTypeBankEdit == 2 ? true : false}
                              />
                              <label className="custom-control-label" for="customRadioInline5">
                                2 Options
                              </label>
                            </div>
                          </div>
                          <div className="card-body">
                            <div className="form-group">
                              <label for="exampleInputEmail1">Question / Step</label>
                              <input
                                type="text"
                                onChange={this.onChangeInput}
                                name="questionMcqEdit"
                                value={this.state.questionMcqEdit}
                                className="form-control"
                                placeholder="Enter Correct Answer"
                              />
                            </div>
                            <div className="form-group">
                              <label for="exampleInputEmail1">Option 1 (Correct)</label>
                              <input
                                type="text"
                                onChange={this.onChangeInput}
                                name="correctMcqEdit"
                                value={this.state.correctMcqEdit}
                                className="form-control"
                                placeholder="Enter Option 1"
                              />
                            </div>
                            <div className="form-group">
                              <label for="exampleInputEmail1">Option 2 (Wrong)</label>
                              <input
                                type="text"
                                onChange={this.onChangeInput}
                                name="alt1McqEdit"
                                value={this.state.alt1McqEdit}
                                className="form-control"
                                placeholder="Enter Option 2"
                              />
                            </div>
                            {this.state.McqTypeBankEdit == 2 ? null : (
                              <div className="form-group">
                                <label for="exampleInputEmail1">Option 3 (Wrong)</label>
                                <input
                                  type="text"
                                  onChange={this.onChangeInput}
                                  name="alt2McqEdit"
                                  value={this.state.alt2McqEdit}
                                  className="form-control"
                                  placeholder="Enter Option 3"
                                />
                              </div>
                            )}
                            {this.state.McqTypeBankEdit == 2 ? null : (
                              <div className="form-group">
                                <label for="exampleInputEmail1">Option 4 (Wrong)</label>
                                <input
                                  type="text"
                                  onChange={this.onChangeInput}
                                  name="alt3McqEdit"
                                  value={this.state.alt3McqEdit}
                                  className="form-control"
                                  placeholder="Enter Option 4"
                                />
                              </div>
                            )}
                            <div className="text-dark pt-3">
                              <input
                                type="checkbox"
                                className="ml-2 mr-2"
                                name="is_mandatoryEdit"
                                onChange={() => this.setState({ is_mandatoryEdit: !this.state.is_mandatoryEdit })}
                                checked={this.state.is_mandatoryEdit}
                              />
                              Is Mandatory
                            </div>

                            <button type="button" onClick={this.onUpdateEvent} className="btn btn-primary mt-3 ml-2">
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.editMode == 2 ? (
                    <div
                      className="modal fade show overlaymodal"
                      style={{ display: "block", paddingRight: "5px", zIndex: "9999" }}
                      tabIndex="-1"
                      role="dialog"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog  modal-xl modal-dialog-centered modal-dialog-scrollable"
                        role="document"
                        style={{ width: "65rem", maxWidth: "75rem" }}
                      >
                        <div className="modal-content p-3">
                          <div className="border-secondary">
                            <div
                              className="pr-2 pl-3 dv-center justify-content-between border-0 border-radious-0"
                              id="headingOne"
                            >
                              <div className="mt-2 top-cont-edit">
                                <h4>Update</h4>
                              </div>
                              <button
                                onClick={this.closeEditContainer}
                                type="button"
                                className="close-s"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Close"
                              >
                                <CloseIcon />
                              </button>
                            </div>
                            <div className="card-body">
                              <div className="form-group">
                                <label for="exampleInputEmail1">Question</label>
                                <input
                                  type="text"
                                  onChange={this.onChangeInput}
                                  name="questionRangeEdit"
                                  value={this.state.questionRangeEdit}
                                  className="form-control"
                                  placeholder="Enter Correct Answer"
                                />
                              </div>
                              <div className="form-group">
                                <label for="exampleInputEmail1">Minimum Value</label>
                                <input
                                  type="number"
                                  onChange={this.onChangeInput}
                                  name="minRangeEdit"
                                  value={this.state.minRangeEdit}
                                  className="form-control"
                                  placeholder="Enter Minimum Value"
                                />
                              </div>
                              <div className="form-group">
                                <label for="exampleInputEmail1">Maximum Value</label>
                                <input
                                  type="number"
                                  onChange={this.onChangeInput}
                                  name="maxRangeEdit"
                                  value={this.state.maxRangeEdit}
                                  className="form-control"
                                  placeholder="Enter Maximum Value"
                                />
                              </div>
                              <div className="text-dark">
                                <input
                                  type="checkbox"
                                  className="ml-2 mr-2"
                                  name="is_mandatoryEdit"
                                  onChange={() => this.setState({ is_mandatoryEdit: !this.state.is_mandatoryEdit })}
                                  checked={this.state.is_mandatoryEdit}
                                />
                                Is Mandatory
                              </div>

                              <button type="button" onClick={this.onUpdateEvent} className="btn btn-primary mt-3 ml-2">
                                Update
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.editMode == 3 ? (
                    <div
                      className="modal fade show overlaymodal"
                      style={{ display: "block", paddingRight: "5px", zIndex: "9999" }}
                      tabIndex="-1"
                      role="dialog"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog  modal-xl modal-dialog-centered modal-dialog-scrollable"
                        role="document"
                        style={{ width: "65rem", maxWidth: "75rem" }}
                      >
                        <div className="modal-content p-3">
                          <div className="pr-2 pl-3 dv-center justify-content-between" id="headingOne">
                            <div className="mt-2 top-cont-edit">
                              <h4>Update</h4>
                            </div>
                            <button
                              onClick={this.closeEditContainer}
                              type="button"
                              className="close-s"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Close"
                            >
                              <CloseIcon />
                            </button>
                          </div>

                          <div className="card-body">
                            <div className="form-group">
                              <label for="exampleInputEmail1">Question</label>
                              <input
                                type="text"
                                onChange={this.onChangeInput}
                                name="questionParentEdit"
                                value={this.state.questionParentEdit}
                                className="form-control"
                                placeholder="Enter Correct Answer"
                              />
                            </div>

                            <div className="text-dark py-3">
                              <input
                                type="checkbox"
                                className="ml-2 mr-2"
                                name="is_mandatoryEdit"
                                onChange={() => this.setState({ is_mandatoryEdit: !this.state.is_mandatoryEdit })}
                                checked={this.state.is_mandatoryEdit}
                              />
                              Is Mandatory
                            </div>

                            <button type="button" onClick={this.onUpdateEvent} className="btn btn-primary ml-2">
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.csv_info_popup ? (
          <div id="popup" className="overlay">
            <div className="popup" style={{ margin: "5% auto", width: "90%" }}>
              <div className="content">
                <div className="card m-b-30">
                  <div className="card-header bg-white heading-cont">
                    <div className="d-flex align-content-center justify-content-between">
                      <h4 className="text-black">Import Data From CSV</h4>
                      <a href={sample_csv} download className="btn btn-primary mr-3" title="Download CSV">
                        <i className="fa fa-download"></i> Download CSV Sample
                      </a>
                    </div>

                    <div>
                      <button onClick={this.addCsvPopup} className="close-s">
                        <CloseIcon />
                      </button>
                      {/* <svg onClick={this.addCsvPopup} className="bi bi-x-circle-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z" clip-rule="evenodd" />
                                            </svg> */}
                    </div>
                    <div className="mt-2" style={{ borderBottom: "1px solid #ccc" }}></div>
                  </div>
                  <div className="card-body">
                    <h3 className="font-18">Instructions :</h3>

                    <ul className="mt-2">
                      <li className="mb-3">
                        <p>
                          <strong>Step 1:</strong> Download a sample CSV template by selecting the “Download CSV”
                          button.
                        </p>
                      </li>
                      <li className="mb-3">
                        <p>
                          {" "}
                          <strong>Step 2:</strong> Use the template to prepare your workflow.
                        </p>
                      </li>
                      <li className="mb-3">
                        <p>
                          <strong>Step 3:</strong> Upload the prepared CSV by selecting the “Upload CSV” button.
                        </p>
                      </li>
                      <li className="mb-3">
                        <p>
                          <strong>Step 4:</strong> Verify your data by clicking the “Verify” button.
                        </p>
                      </li>
                      <li className="mb-3">
                        <p>
                          <strong>Step 5:</strong> Check for warning if any. Otherwise, select the “Save” button to
                          ensure uploading.
                        </p>
                      </li>
                    </ul>

                    <div className="mt-2 mb-2" style={{ borderBottom: "1px solid #ccc" }}></div>

                    <div class="alert alert-danger" role="alert">
                      <strong>Warning:</strong> A column is deleted from the CSV template. Each parent should have at
                      least one child.
                    </div>

                    <div className="text-center">
                      <label class="btn btn-primary file_upload position-relative mb-0" for="input-file" role="button">
                        <i className="fa fa-upload"></i> Upload CSV
                        <input type="file" onChange={this.addCsv} name="logo" className="form-control" accept=".csv" />
                      </label>
                    </div>

                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {this.state.uploadCsv ? <Csv_Validate node={this.state.csv_data} CloseCsv={this.CloseCsv} /> : null}

      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.userData,
});

// export default CreateTaskBank;
export default withRouter(connect(mapStateToProps)(CreateTaskBank));

class TaskTree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmPopUp: false,
      isToggleOn: true,
      isToggle3On: true,
      isToggle4On: true,
      isToggle5On: true,
      isToggle6On: true,
      isToggle7On: true,
      // usersList: [],
      departmentUserList: [],
      workflow_id: "",
      checkedSupport: [],
      checkedNotification: [],
      showSupportModal: false,
      showNotificationModal: false,

      heirarchy: [],
      typeHierarchy: [],
      simple: [],
      openCreateParent: false,
      selectedParent: 0,
      iseditmode: false,
      selectednode: {},
    };
  }

  componentDidMount() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    // this.getUserList()
    this.getDataFromType();
    // setInterval(() => this.setState({ departmentUserList }), 1000);
  }

  toggleHandler = () => {
    this.setState((state) => ({
      isToggleOn: !state.isToggleOn,
    }));
  };

  toggleHandler3 = () => {
    this.setState((state) => ({
      isToggle3On: !state.isToggle3On,
    }));
  };
  toggleHandler4 = () => {
    this.setState((state) => ({
      isToggle4On: !state.isToggle4On,
    }));
  };
  toggleHandler5 = () => {
    this.setState((state) => ({
      isToggle5On: !state.isToggle5On,
    }));
  };

  toggleHandler6 = () => {
    this.setState((state) => ({
      isToggle6On: !state.isToggle6On,
    }));
  };

  toggleHandler7 = () => {
    this.setState((state) => ({
      isToggle7On: !state.isToggle7On,
    }));
  };
  selectedNodeToDelete = (node, delete_type) => {
    this.setState({
      confirmPopUp: true,
      delete_type: delete_type,
      selectedIdForDelete: node.task_id,
      selectedQue: node.task[0].question,
    });
  };
  deleteSubTasks = (node, delete_type) => {
    if (delete_type == 3) {
      this.setState({
        confirmPopUp: true,
        delete_type: delete_type,
        selectedIdForDelete: node.task_id,
        selectedQue: node.task[0].question,
      });
    } else {
      this.setState({
        confirmPopUp: true,
        delete_type: delete_type,
        selectedIdForDelete: node.subTask_id,
        selectedQue: node.task[0].question,
      });
    }
  };
  deleteTasksTypeFour = (node, delete_type) => {
    this.setState({ confirmPopUp: true, delete_type: delete_type, selectedIdForDelete: node.task_id, selectedQue: "" });
  };
  deleteTasks = () => {
    this.setState({ confirmPopUp: false });
    this.props.deleteTasks(this.state.selectedIdForDelete, this.state.delete_type);
  };
  // getUserList = () => {
  //     // User List
  //     let _this = this;
  //     let headers = {
  //         'user_id': (ud.id).toString(),
  //         'session_id': (ud.session_id).toString(),
  //         'user_type': (ud.usertype).toString(),
  //         'main_id': (ud.main_id).toString(),
  //         'jwt_token': (jwt),
  //         'c_id': (ud.c_id).toString()
  //     }
  //     var data = {
  //      s_id: ud.main_id,
  //      user_id: "",
  //      user_type: ud.usertype
  //     }
  //     axios.post(`${SERVER_IP}/usersList`, data, { withCredentials: true, headers: headers })
  //     .then(function (response) {
  //         if (response.data.error === false) {
  //             if (response.data.usersList) {
  //                 _this.setState({ usersList: response.data.usersList });
  //             }
  //         }
  //     })
  //     .catch(function (error) {
  //         console.log(error);
  //     });
  // }
  getCheckedSupport = (task_type, bank_id) => {
    const version_info = JSON.parse(sessionStorage.getItem("version_info"));
    let data = {
      workflow_id: version_info.workflow_id,
      task_type,
      version_id: version_info.id,
      bank_id,
    };
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workflow/suppoertUser`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          _this.setState({ checkedSupport: response.data.workflowUsers });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  updateSupport = (task_type, bank_id) => {
    const version_info = JSON.parse(sessionStorage.getItem("version_info"));
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    let data = {
      workflow_id: version_info.workflow_id,
      support_user_id: this.state.checkedSupport,
      task_type,
      version_id: version_info.id,
      bank_id,
    };
    axios
      .post(`${SERVER_IP}/workflow/suppoertUserUpdate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          swal(response.data.message);
          _this.setState({ workflow_id: "" });
          _this.setState({ showSupportModal: false });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  getCheckedNotification = (task_type, bank_id) => {
    const version_info = JSON.parse(sessionStorage.getItem("version_info"));
    let data = {
      workflow_id: version_info.workflow_id,
      task_type,
      version_id: version_info.id,
      bank_id,
    };
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workflow/notificationUser`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          _this.setState({ checkedNotification: response.data.workflowNotificationUsers });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  updateNotification = (task_type, bank_id) => {
    const version_info = JSON.parse(sessionStorage.getItem("version_info"));
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    let data = {
      workflow_id: version_info.workflow_id,
      notification_user_id: this.state.checkedNotification,
      task_type,
      version_id: version_info.id,
      bank_id,
    };
    axios
      .post(`${SERVER_IP}/workflow/notificationUserUpdate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          swal(response.data.message);
          _this.setState({ workflow_id: "" });
          _this.setState({ showNotificationModal: false });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  // convert = (array) => {
  //   var map = {};
  //   for (var i = 0; i < array.length; i++) {
  //     var obj = array[i];
  //     obj.children = [];

  //     map[obj.id] = obj;

  //     var parent_id = obj.parent_id || "-";
  //     if (!map[parent_id]) {
  //       map[parent_id] = {
  //         children: [],
  //       };
  //     }
  //     map[parent_id].children.push(obj);
  //   }

  //   return map["-"].children;
  // };
  convert = (array) => {
    const map = {};
    const roots = [];

    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      obj.children = [];
      map[obj.id] = obj;
    }

    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      if (obj.parent_id !== null && obj.parent_id !== undefined && map[obj.parent_id]) {
        map[obj.parent_id].children.push(obj);
      } else {
        roots.push(obj);
      }
    }

    return roots;
  };
  getDataFromType = () => {
    var data = {
      jwt: jwt,
      s_id: ud.main_id,
    };
    let _this = this;
    var heirarchy = this.state.heirarchy;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/view/types`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          var r = _this.convert(response.data.result.result);
          _this.setState({ simple: response.data.result.result, typeHierarchy: r });
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.getDataFromType();
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  render() {
    var randomno = Math.floor(Math.random() * (999 - 100 + 1) + 100);
    return (
      // <div className="ui-state-default ui-st1">
      <div className="ui-state-default">
        {this.state.confirmPopUp ? (
          <div className="cd-popup is-visible" role="alert">
            <div className="cd-popup-container p-4">
              <div className="d-flex justify-content-center px-2">
                <h5 className="m-0 p-0 text-left">{this.state.selectedQue}</h5>
                {/* <a onClick={() => this.setState({ confirmPopUp: false })} className="close-s cursor-pointer">
                  <CloseIcon />
                </a> */}
              </div>
              <p className="p-5">Are you sure you want to delete this task?</p>
              {/* <h4 className="child-p p-4"></h4> */}
              <ul className="deleteconfirbtn mb-0">
                <li className="nobtn" onClick={() => this.setState({ confirmPopUp: false })}>
                  Cancel
                </li>
                <li className="yesbtn" onClick={this.deleteTasks}>
                  Confirm
                </li>
              </ul>
            </div>
          </div>
        ) : null}

        <div className="accordion" id="accordion_task">
          <div className="card mb-2">
            <div>
              <div className="card-header p-1" id={`headingOne${randomno}`}>
                <div className="mb-0 dv-center space-between">
                  <div className="dv-center">
                    <button
                      onClick={this.toggleHandler}
                      className="btn btn-link arrow-s"
                      type="button"
                      data-toggle="collapse"
                      data-target={`#collapseOne${randomno}`}
                      aria-expanded="true"
                      aria-controls={`#collapseOne${randomno}`}
                    >
                      <i className={this.state.isToggleOn ? "fa fa-chevron-right" : "fa fa-chevron-down"}></i>
                    </button>
                    <h6 className="p-1 mb-0">
                      <span className="mr-2">
                        {this.props.node.task_type == 1 ? <i className="fa fa-th-list"></i> : null}
                        {this.props.node.task_type == 2 ? <i className="fa fa-sort-numeric-asc"></i> : null}
                        {this.props.node.task_type == 3 ? <i className="fa fa-sitemap"></i> : null}
                      </span>
                      {this.props.index + 1} : {this.props.node.task[0].question}
                    </h6>
                  </div>
                  <div className="dv-center">
                    {this.props.node.is_mandatory ? (
                      <a className="badge badge-success text-white p-2 rounded">Compulsory</a>
                    ) : (
                      <a className="badge badge-danger text-white p-2 rounded">Non-Compulsory</a>
                    )}

                    {/* {!this.props.isMobile && (
                      <>
                        <button
                          type="button"
                          className="btn btn-round btn-info mx-2"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Add the personal who are to be notified for this particular step in case of a deviation"
                          onClick={() => {
                            this.getCheckedNotification(this.props.node.task_id, this.props.node.bank_id);
                            this.setState({ showNotificationModal: true });
                          }}
                        >
                          <i>
                            <NotifyIcon />
                          </i>
                        </button>

                        <button
                          type="button"
                          className="btn btn-round btn-info mr-2"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Add the support team who would be able to support the field personnel with issues related to this particular step"
                          onClick={() => {
                            this.getCheckedSupport(this.props.node.task_id, this.props.node.bank_id);
                            this.setState({ showSupportModal: true });
                          }}
                        >
                          <i class="mdi mdi-headset"></i>
                        </button>
                      </>
                    )} */}

                    {this.state.showSupportModal && (
                      // Add Support Modal
                      <div
                        className="modal fade show overlaymodal"
                        style={{ display: "block", paddingRight: "5px", zIndex: "9999" }}
                        tabIndex="-1"
                        role="dialog"
                        aria-hidden="true"
                      >
                        <div
                          className="modal-dialog  modal-xl modal-dialog-centered modal-dialog-scrollable"
                          role="document"
                          style={{ width: "65rem", maxWidth: "75rem" }}
                        >
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title text-dark">Add Support</h5>
                              <button
                                type="button"
                                className="close-s"
                                onClick={() => this.setState({ showSupportModal: false })}
                              >
                                <CloseIcon />
                              </button>
                            </div>

                            <div className="modal-body py-3 px-5">
                              <div
                                style={{ width: "60rem", height: "69vh", overflowY: "auto", paddingRight: "0.5rem" }}
                              >
                                {this.state.typeHierarchy.map((i) => (
                                  <TreeNode
                                    node={i}
                                    children={i.children}
                                    selectNode={this.selectedNode}
                                    editNode={this.editNode}
                                  />
                                ))}
                              </div>
                              <div id="middleBorder"></div>
                              <div>
                                {!departmentUserList.length === 0 ? (
                                  <p className="form-check-label text-dark text-center" htmlFor="defaultCheck1">
                                    No record found
                                  </p>
                                ) : (
                                  departmentUserList.map((element, index) => {
                                    return (
                                      <div className="form-check" key={index}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={this.state.checkedSupport.indexOf(element.user_id) > -1}
                                          onChange={() => {
                                            const arr = [...this.state.checkedSupport];
                                            if (arr.indexOf(element.user_id) > -1) {
                                              const index = arr.indexOf(element.user_id);
                                              arr.splice(index, 1);
                                            } else {
                                              arr.push(element.user_id);
                                            }
                                            this.setState({ checkedSupport: arr });
                                          }}
                                        />
                                        <label className="form-check-label text-dark" htmlFor="defaultCheck1">
                                          {element.name} ({element.email})
                                        </label>
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => this.updateSupport(this.props.node.task_id, this.props.node.bank_id)}
                              >
                                Save changes
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {this.state.showNotificationModal && (
                      // Notification Modal
                      <div
                        className="modal fade show overlaymodal"
                        style={{ display: "block", paddingRight: "5px", zIndex: "9999" }}
                        tabIndex="-1"
                        role="dialog"
                        aria-hidden="true"
                      >
                        <div
                          className="modal-dialog  modal-xl modal-dialog-centered modal-dialog-scrollable"
                          role="document"
                          style={{ width: "65rem", maxWidth: "75rem" }}
                        >
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title text-dark">Notification</h5>
                              <button
                                type="button"
                                className="close-s"
                                onClick={() => this.setState({ showNotificationModal: false })}
                              >
                                <CloseIcon />
                              </button>
                            </div>
                            <div className="modal-body py-3 px-5">
                              {/* <div style={{ width: "30rem" }}>
                                {this.state.typeHierarchy.map((i) => (
                                  <TreeNode
                                    node={i}
                                    children={i.children}
                                    selectNode={this.selectedNode}
                                    editNode={this.editNode}
                                  />
                                ))}
                              </div> */}
                              <div id="middleBorder"></div>
                              <div>
                                {departmentUserList.length === 0 ? (
                                  <>
                                    <NoDataFound headText="No record found" />
                                    {/* <p className="form-check-label text-dark text-center" htmlFor="defaultCheck1">
                                    No record found
                                  </p> */}
                                  </>
                                ) : (
                                  departmentUserList.map((element, index) => {
                                    return (
                                      <div className="form-check" key={index}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={this.state.checkedNotification.indexOf(element.user_id) > -1}
                                          onChange={() => {
                                            const arr = [...this.state.checkedNotification];
                                            if (arr.indexOf(element.user_id) > -1) {
                                              const index = arr.indexOf(element.user_id);
                                              arr.splice(index, 1);
                                            } else {
                                              arr.push(element.user_id);
                                            }
                                            this.setState({ checkedNotification: arr });
                                          }}
                                        />
                                        <label className="form-check-label text-dark" htmlFor="defaultCheck1">
                                          {element.name} ({element.email})
                                        </label>
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() =>
                                  this.updateNotification(this.props.node.task_id, this.props.node.bank_id)
                                }
                              >
                                Save changes
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {!this.props.isMobile && (
                      <>
                        {this.props.node.task_type == 3 ? (
                          <button
                            onClick={() => this.props.AddSubTasks(this.props.node, "L1")}
                            type="button"
                            className="btn btn-round btn-info mr-2"
                          >
                            {/* <i class="fa fa-plus" aria-hidden="true"></i> */}
                            <i>
                              <PLusIconDark />{" "}
                            </i>
                          </button>
                        ) : (
                          <button
                            onClick={() => this.props.editTasks(this.props.node, "mainTask")}
                            type="button"
                            className="btn btn-round btn-info mr-2"
                          >
                            {/* <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-pencil" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z" />
                                                    <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z" />
                                                </svg> */}
                            {/* <i class="mdi mdi-pencil"></i> */}
                            <i>
                              <EditIcon />
                            </i>
                          </button>
                        )}
                      </>
                    )}

                    {!this.props.isMobile && this.props.node.task_type == 3 ? (
                      <button
                        onClick={() => this.props.editTasks(this.props.node, "mainTask")}
                        type="button"
                        className="btn btn-round btn-info mr-2"
                      >
                        {/* <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-pencil" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z" />
                                                    <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z" />
                                                </svg> */}
                        <EditIcon />
                      </button>
                    ) : null}

                    {!this.props.isMobile && (
                      <button
                        onClick={() => this.selectedNodeToDelete(this.props.node, 1)}
                        type="button"
                        className="btn btn-round btn-info"
                      >
                        {/* <i class="fa fa-trash"></i> */}
                        <DeleteRedIcon />
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div id={`collapseOne${randomno}`} className="collapse" aria-labelledby={`headingOne${randomno}`}>
                {/* For MCQ Task */}
                {this.props.node.task_type === 1 ? (
                  <div className="card-body cus_border_E sortable2">
                    <div className="card pc-card card-top-cont ui-st2" id="q1">
                      <div className="mb-0 text-dark dv-center space-between">
                        <div className="dv-center">
                          {this.props.node.task[0].correctAction?.length > 0 && (
                            <button
                              onClick={this.toggleHandler4}
                              className="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoCorrect${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle4On ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                            </button>
                          )}
                          <h6
                            className={`text-dark mb-0 ${this.props.node.task[0].correctAction?.length > 0 ? "" : "pl-4"
                              }`}
                          >
                            {" "}
                            Option 1 (Correct) : {this.props.node.task[0].correct}
                          </h6>
                        </div>
                        {/* {!this.props.isMobile && (
                          <div>
                            <button
                              onClick={() => this.props.subTaskPlusClick(this.props.node, "M_C")}
                              type="button"
                              className="addsubtaskbtn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Add Subtask"
                              id="stp3-btn"
                            >
                              <i className="mdi mdi-plus"></i>
                            </button>
                          </div>
                        )} */}
                      </div>
                      <div
                        id={`collapseTwoCorrect${randomno}`}
                        className="collapse"
                        aria-labelledby={`headingOne${randomno}`}
                      >
                        {this.props.node.task[0].correctAction.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteSubTasks={this.deleteSubTasks}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                            AddSubTasks={this.props.AddSubTasks}
                          />
                        ))}
                      </div>
                    </div>
                    <div className="card pc-card card-top-cont ui-st2" id="q1">
                      <div className="mb-0 text-white dv-center space-between">
                        <div className="dv-center">
                          {this.props.node.task[0].a1Action?.length > 0 && (
                            <button
                              onClick={this.toggleHandler5}
                              className="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoAlt1${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle5On ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                            </button>
                          )}
                          <h6
                            className={`text-dark mb-0 ${this.props.node.task[0].a1Action?.length > 0 ? "" : "pl-4"}`}
                          >
                            {" "}
                            Option 2 (Wrong) : {this.props.node.task[0].alternative_1}
                          </h6>
                        </div>
                        {/* {!this.props.isMobile && (
                          <div>
                            <button
                              onClick={() => this.props.subTaskPlusClick(this.props.node, "M_A1")}
                              type="button"
                              className="addsubtaskbtn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Add Subtask"
                              id="stp3-btn"
                            >
                              <i className="mdi mdi-plus"></i>
                            </button>
                          </div>
                        )} */}
                      </div>
                      <div
                        id={`collapseTwoAlt1${randomno}`}
                        className="collapse"
                        aria-labelledby={`headingOne${randomno}`}
                      >
                        {this.props.node.task[0].a1Action.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteSubTasks={this.deleteSubTasks}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                            AddSubTasks={this.props.AddSubTasks}
                          />
                        ))}
                      </div>
                    </div>
                    {this.props.node.task[0].mcq_type === 1 ? (
                      <div className="card pc-card card-top-cont ui-st2" id="q1">
                        <div className="mb-0 text-white dv-center space-between">
                          <div className="dv-center">
                            {this.props.node.task[0].a2Action?.length > 0 && (
                              <button
                                onClick={this.toggleHandler6}
                                className="btn btn-link text-dark arrow-s"
                                type="button"
                                data-toggle="collapse"
                                data-target={`#collapseTwoAlt2${randomno}`}
                                aria-expanded="true"
                                aria-controls={`#collapseOne${randomno}`}
                              >
                                <i className={this.state.isToggle6On ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                              </button>
                            )}
                            <h6
                              className={`text-dark mb-0 ${this.props.node.task[0].a2Action?.length > 0 ? "" : "pl-4"}`}
                            >
                              {" "}
                              Option 3 (Wrong) : {this.props.node.task[0].alternative_2}
                            </h6>
                          </div>
                          {/* {!this.props.isMobile && (
                            <div>
                              <button
                                type="button"
                                onClick={() => this.props.subTaskPlusClick(this.props.node, "M_A2")}
                                className="addsubtaskbtn"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Add Subtask"
                                id="stp3-btn"
                              >
                                <i className="mdi mdi-plus"></i>
                              </button>
                            </div>
                          )} */}
                        </div>
                        <div
                          id={`collapseTwoAlt2${randomno}`}
                          className="collapse"
                          aria-labelledby={`headingOne${randomno}`}
                        >
                          {this.props.node.task[0].a2Action.map((list, index) => (
                            <SubTask
                              list={list}
                              editTasks={this.props.editTasks}
                              deleteTasks={this.selectedNodeToDelete}
                              deleteSubTasks={this.deleteSubTasks}
                              deleteTasksTypeFour={this.deleteTasksTypeFour}
                              AddSubTasks={this.props.AddSubTasks}
                            />
                          ))}
                        </div>
                      </div>
                    ) : null}
                    {this.props.node.task[0].mcq_type === 1 ? (
                      <div className="card pc-card card-top-cont ui-st2" id="q1">
                        <div className="mb-0 text-white dv-center space-between">
                          <div className="dv-center">
                            {this.props.node.task[0].a3Action?.length > 0 && (
                              <button
                                onClick={this.toggleHandler7}
                                className="btn btn-link text-dark arrow-s"
                                type="button"
                                data-toggle="collapse"
                                data-target={`#collapseTwoAlt3${randomno}`}
                                aria-expanded="true"
                                aria-controls={`#collapseOne${randomno}`}
                              >
                                <i className={this.state.isToggle7On ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                              </button>
                            )}
                            <h6
                              className={`text-dark mb-0 ${this.props.node.task[0].a3Action?.length > 0 ? "" : "pl-4"}`}
                            >
                              Option 4 (Wrong) : {this.props.node.alternative_3}
                            </h6>
                          </div>
                          {/* {!this.props.isMobile && (
                            <div>
                              <button
                                type="button"
                                onClick={() => this.props.subTaskPlusClick(this.props.node, "M_A3")}
                                className="addsubtaskbtn"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Add Subtask"
                                id="stp3-btn"
                              >
                                <i className="mdi mdi-plus"></i>
                              </button>
                            </div>
                          )} */}
                        </div>
                        <div
                          id={`collapseTwoAlt3${randomno}`}
                          className="collapse"
                          aria-labelledby={`headingOne${randomno}`}
                        >
                          {this.props.node.task[0].a3Action.map((list, index) => (
                            <SubTask
                              list={list}
                              editTasks={this.props.editTasks}
                              deleteTasks={this.selectedNodeToDelete}
                              deleteSubTasks={this.deleteSubTasks}
                              deleteTasksTypeFour={this.deleteTasksTypeFour}
                              AddSubTasks={this.props.AddSubTasks}
                            />
                          ))}
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : null}
                {/* For Range Task */}
                {this.props.node.task_type === 2 ? (
                  <div className="card-body cus_border_E sortable2">
                    <div className="card pc-card card-top-cont ui-st2" id="q1">
                      <div className="mb-0 text-white dv-center space-between">
                        <div className="dv-center">
                          {this.props.node.task[0].maxAction?.length > 0 && (
                            <button
                              onClick={this.toggleHandler4}
                              className="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoRMax${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle4On ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                            </button>
                          )}
                          <h6
                            className={`text-dark mb-0 ${this.props.node.task[0].maxAction?.length > 0 ? "" : "pl-4"}`}
                          >
                            {" "}
                            Maximum Value: {this.props.node.task[0].max_value}
                          </h6>
                        </div>
                        {/* {!this.props.isMobile && (
                          <div>
                            <button
                              type="button"
                              onClick={() => this.props.subTaskPlusClick(this.props.node, "R_Max")}
                              className="addsubtaskbtn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Add"
                              id="stp3-btn"
                            >
                              <i className="mdi mdi-plus"></i>
                            </button>
                          </div>
                        )} */}
                      </div>
                      <div
                        id={`collapseTwoRMax${randomno}`}
                        className="collapse"
                        aria-labelledby={`headingOne${randomno}`}
                      >
                        {this.props.node.task[0].maxAction.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteSubTasks={this.deleteSubTasks}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                            AddSubTasks={this.props.AddSubTasks}
                          />
                        ))}
                      </div>
                    </div>
                    <div className="card pc-card card-top-cont ui-st2" id="q1">
                      <div className="mb-0 text-white dv-center space-between">
                        <div className="dv-center">
                          {this.props.node.task[0].correctAction?.length > 0 && (
                            <button
                              onClick={this.toggleHandler7}
                              className="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoRC${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle7On ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                            </button>
                          )}
                          <h6
                            className={`text-dark mb-0 ${this.props.node.task[0].correctAction?.length > 0 ? "" : "pl-4"
                              }`}
                          >
                            {" "}
                            Correct Value
                          </h6>
                        </div>
                        {/* {!this.props.isMobile && (
                          <div>
                            <button
                              type="button"
                              onClick={() => this.props.subTaskPlusClick(this.props.node, "R_C")}
                              className="addsubtaskbtn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Add"
                              id="stp3-btn"
                            >
                              <i className="mdi mdi-plus"></i>
                            </button>
                          </div>
                        )} */}
                      </div>
                      <div
                        id={`collapseTwoRC${randomno}`}
                        className="collapse"
                        aria-labelledby={`headingOne${randomno}`}
                      >
                        {this.props.node.task[0].correctAction.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteSubTasks={this.deleteSubTasks}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                            AddSubTasks={this.props.AddSubTasks}
                          />
                        ))}
                      </div>
                    </div>
                    <div className="card pc-card card-top-cont ui-st2" id="q1">
                      <div className="mb-0 text-white dv-center space-between">
                        <div className="dv-center">
                          {this.props.node.task[0].minAction?.length > 0 && (
                            <button
                              onClick={this.toggleHandler6}
                              className="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoRMIN${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle6On ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                            </button>
                          )}
                          <h6
                            className={`text-dark mb-0 ${this.props.node.task[0].minAction?.length > 0 ? "" : "pl-4"}`}
                          >
                            {" "}
                            Minimum Value: {this.props.node.task[0].min_value}
                          </h6>
                        </div>
                        {/* {!this.props.isMobile && (
                          <div>
                            <button
                              type="button"
                              onClick={() => this.props.subTaskPlusClick(this.props.node, "R_Min")}
                              className="addsubtaskbtn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Add"
                              id="stp3-btn"
                            >
                              <i className="mdi mdi-plus"></i>
                            </button>
                          </div>
                        )} */}
                      </div>
                      <div
                        id={`collapseTwoRMIN${randomno}`}
                        className="collapse"
                        aria-labelledby={`headingOne${randomno}`}
                      >
                        {this.props.node.task[0].minAction.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteSubTasks={this.deleteSubTasks}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                            AddSubTasks={this.props.AddSubTasks}
                          />
                        ))}
                      </div>
                    </div>

                    {/* {node} */}
                  </div>
                ) : null}
                {/* For parent child Task */}
                {this.props.node.task_type === 3 ? (
                  <div className="card-body cus_border_E sortable2">
                    {/* <div className="card-body cus_border_E sortable2"> */}
                    <div className="card pc-card card-top-cont ui-st2" id="q1">
                      <div className="mb-0 text-white dv-center space-between">
                        <div className="dv-center">
                          {/* rob2 */}
                          {this.props.node.task[0].correctAction?.length > 0 && (
                            <button
                              onClick={this.toggleHandler5}
                              className="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoPC${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle5On ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                            </button>
                          )}
                          <h6
                            className={`text-dark mb-0 ${this.props.node.task[0].correctAction?.length > 0 ? "" : "pl-4"
                              }`}
                          >
                            {" "}
                            Complete Action{" "}
                          </h6>
                        </div>
                        {/* {!this.props.isMobile && (
                          <div>
                            <button
                              onClick={() => this.props.subTaskPlusClick(this.props.node, "P_C")}
                              type="button"
                              className="addsubtaskbtn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Add Subtask"
                              id="stp3-btn"
                            >
                              <i className="mdi mdi-plus"></i>
                            </button>
                          </div>
                        )} */}
                      </div>

                      <div
                        id={`collapseTwoPC${randomno}`}
                        className="collapse"
                        aria-labelledby={`headingOne${randomno}`}
                      >
                        {this.props.node.task[0].correctAction.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                            deleteSubTasks={this.deleteSubTasks}
                            AddSubTasks={this.props.AddSubTasks}
                          />
                        ))}
                      </div>
                    </div>
                    {/* </div> */}
                    <div className="card pc-card ui-st2" id="q1">
                      <div className="mb-0 text-white dv-center space-between">
                        <div className="dv-center"></div>
                      </div>
                      {this.props.node.task[0].children.map((childlist, childindex) => (
                        <ParentChildSubTask
                          node={childlist}
                          children={childlist.children}
                          editTasks={this.props.editTasks}
                          index={childindex}
                          showchild={false}
                          AddSubTasks={this.props.AddSubTasks}
                          deleteSubTasks={this.deleteSubTasks}
                          editTasksType="subTask"
                        />
                      ))}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export let departmentUserList = [];

class TreeNode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };
  }
  getInitialState = () => {
    return { isVisible: false };
  };

  toggle = (e) => {
    this.setState({ isVisible: !this.state.isVisible });
  };
  getChild = (prop) => {
    prop.selectNode(prop.node.id);
  };
  editChild = (prop) => {
    prop.editNode(prop.node);
  };
  getDepartmentUserList = (department_type_id) => {
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    let data = { department_type_id };
    axios
      .post(`${SERVER_IP}/department/usersList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          departmentUserList = response.data.usersList;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  render() {
    var icon = this.state.isVisible ? "fa fa-angle-up" : "fa fa-angle-down";
    var span;
    var nodes;

    if (this.props.children) {
      span = (
        <span className="icon" onClick={this.toggle}>
          <i className={icon}></i>
        </span>
      );

      if (this.state.isVisible) {
        nodes = this.props.children.map((i) => <TreeNode node={i} children={i.children} />);
      }
    }

    return (
      <li className="accordion-item pc-card mb-2 text-muted">
        <div className="accordion-title-parent">
          <div className="d-flex">
            {span}
            <div
              className="bag-icon dv-center ml-1"
              style={{ cursor: "pointer" }}
              onClick={() => this.getDepartmentUserList(this.props.node.id)}
            >
              <i className="mdi mdi-briefcase"></i>
              {this.props.node.name}
            </div>
          </div>
        </div>
        <ul className="accordion-content">{nodes}</ul>
      </li>
    );
  }
}

class ParentChildSubTask extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggle2On: true,
    };
  }
  toggleHandler2 = () => {
    this.setState((state) => ({
      isToggle2On: !state.isToggle2On,
    }));
  };
  render() {
    var node;
    if (this.props.node) {
      if ("task" in this.props.node) {
        if (this.props.node.task[0] && this.props.node.task[0].hasOwnProperty("children")) {
          node = this.props.node.task[0].children.map((childlist, childindex) => (
            <ParentChildSubTask
              node={childlist}
              children={childlist.children}
              editTasks={this.props.editTasks}
              index={childindex}
              deleteSubTasks={this.props.deleteSubTasks}
              showchild={false}
              AddSubTasks={this.props.AddSubTasks}
              editTasksType={this.props.editTasksType}
            />
          ));
        }
      }
    }

    //  this.props.node.task[0].children != undefined ? this.props.node.task[0].children.map((childlist, childindex) => <ParentChildSubTask node={childlist} children={childlist.children} index={childindex} />) : null;
    var randomno = Math.floor(Math.random() * (999 - 100 + 1) + 100);

    return (
      <div>
        <div className="accordion" id="accordion_task">
          <div className="stp2 mb-3">
            <div className="form-content pl-3 pr-3">
              {this.props.node.task_type == 3 ? (
                <div className="card mt-2 ml-3 mr-3 p-child" id="in-q1">
                  <div className="mb-0 text-dark dv-center space-between pt-2 pb-2 jksdbkasjdks ">
                    <div className="dv-center pl-3">
                      {/* rob */}
                      {this.props?.node?.length > 0 && (
                        <button
                          onClick={this.toggleHandler2}
                          className="btn btn-link text-dark arrow-s"
                          type="button"
                          data-toggle="collapse"
                          data-target={`#collapseOne${randomno}`}
                          aria-expanded="true"
                          aria-controls={`#collapseOne${randomno}`}
                        >
                          <i className={this.state.isToggle2On ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                        </button>
                      )}

                      <div className="mr-2">
                        <i className="fa fa-sitemap"></i>
                      </div>
                      <h6 className="text-dark mb-0">{this.props.node.task[0].question}</h6>
                    </div>
                    <div>
                      {this.props.node.is_mandatory ? (
                        <a className="badge badge-success mr-2">Compulsory</a>
                      ) : (
                        <a className="badge badge-danger text-white mr-2">Non-Compulsory</a>
                      )}
                      <button
                        onClick={() => this.props.AddSubTasks(this.props.node, "L2")}
                        type="button"
                        className="edit-btn trash-icon-b icon-b icon-s mr-2"
                      // data-toggle="tooltip"
                      // data-placement="top"
                      // title="Edit"
                      >
                        {/* <i className="fa fa-plus" aria-hidden="true"></i> */}
                        <i>
                          <PLusIconDark />{" "}
                        </i>
                      </button>
                      {this.props.showchild && this.props.node.parent_id == 0 ? (
                        <button
                          onClick={() => this.props.editTasks(this.props.node, this.props.editTasksType)}
                          type="button"
                          className="edit-btn trash-icon-b icon-b icon-s mr-2"
                        // data-toggle="tooltip"
                        // data-placement="top"
                        // title="Edit"
                        >
                          <svg
                            width="1em"
                            height="1em"
                            viewBox="0 0 16 16"
                            className="bi bi-pencil"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z"
                            />
                            <path
                              fill-rule="evenodd"
                              d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z"
                            />
                          </svg>
                        </button>
                      ) : (
                        <button
                          onClick={() => this.props.editTasks(this.props.node, "PCTask")}
                          type="button"
                          className="edit-btn trash-icon-b icon-b icon-s mr-2"
                        // data-toggle="tooltip"
                        // data-placement="top"
                        // title="Edit"
                        >
                          <EditIcon />
                          {/* <svg
                            width="1em"
                            height="1em"
                            viewBox="0 0 16 16"
                            className="bi bi-pencil"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z"
                            />
                            <path
                              fill-rule="evenodd"
                              d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z"
                            />
                          </svg> */}
                        </button>
                      )}
                      {this.props.showchild && this.props.node.parent_id == 0 ? (
                        <button
                          type="button"
                          className="edit-btn trash-icon-b icon-b icon-s"
                          onClick={() => this.props.deleteSubTasks(this.props.node, 2)}
                        // data-toggle="tooltip"
                        // data-placement="top"
                        // title="Delete"
                        >
                          <i>
                            <DeleteRedIcon />
                          </i>
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="edit-btn trash-icon-b icon-b icon-s mr-2"
                          onClick={() => this.props.deleteSubTasks(this.props.node, 3)}
                        // data-toggle="tooltip"
                        // data-placement="top"
                        // title="Delete"
                        >
                          <i>
                            <DeleteRedIcon />
                          </i>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
              {this.props.node.task_type == 1 && this.props.node?.task[0] ? (
                <div className="card mt-2 ml-3 mr-3" id="in-q1">
                  <div className="mb-0 pb-2 text-dark dv-center space-between p-c-cont ">
                    <div className="dv-center justify-content-between pl-2">
                      <div className="dv-center">
                        <h6 className="text-dark mb-0 pl-3 pr-3 pt-3">
                          <span className="mr-2">
                            <i className="fa fa-th-list"></i>
                          </span>{" "}
                          {this.props.node.task[0].question}
                        </h6>
                      </div>
                      <div className="pl-3">
                        {this.props.node.is_mandatory ? (
                          <a className="badge badge-success mr-2">Compulsory</a>
                        ) : (
                          <a className="badge badge-danger text-white mr-2">Non-Compulsory</a>
                        )}
                        {!this.props.isMobile && (
                          <>
                            <button
                              onClick={() => this.props.editTasks(this.props.node, "PCTask")}
                              type="button"
                              className="edit-btn trash-icon-b icon-b mr-2"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Edit"
                            >
                              <EditIcon />
                              {/* <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 16 16"
                                className="bi bi-pencil"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z"
                                />
                                <path
                                  fill-rule="evenodd"
                                  d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z"
                                />
                              </svg> */}
                            </button>
                            <button
                              type="button"
                              className="edit-btn trash-icon-b icon-b icon-s"
                              onClick={() => this.props.deleteSubTasks(this.props.node, 3)}
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Delete"
                            >
                              <i>
                                <DeleteRedIcon />
                              </i>
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="cont-4-card tbl">
                      <div className="inner-cont">{this.props.node.task[0].correct}</div>
                      <div className="inner-cont">{this.props.node.task[0].alternative_1}</div>

                      {this.props.node.task[0].mcq_type === 2 ? null : (
                        <div className="inner-cont">{this.props.node.task[0].alternative_2}</div>
                      )}
                      {this.props.node.task[0].mcq_type === 2 ? null : (
                        <div className="inner-cont">{this.props.node.task[0].alternative_3}</div>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
              {this.props.node.task_type == 2 && this.props.node?.task[0] ? (
                <div className="card mt-2 ml-3 mr-3 " id="in-q1">
                  <div className="mb-0 pb-2 text-dark dv-center space-between p-c-cont ">
                    <div className="dv-center justify-content-between">
                      <div className="dv-center">
                        <h6 className="text-dark mb-0 pl-3 pr-3 pt-3">
                          <span className="mr-2">
                            <i className="fa fa-sort-numeric-asc"></i>
                          </span>{" "}
                          {this.props.node?.task[0]?.question}
                        </h6>
                      </div>
                      <div className="mr-2">
                        {this.props.node.is_mandatory ? (
                          <a className="badge badge-success mr-2">Compulsory</a>
                        ) : (
                          <a className="badge badge-danger text-white mr-2">Non-Compulsory</a>
                        )}

                        <button
                          onClick={() => this.props.editTasks(this.props.node, "PCTask")}
                          type="button"
                          className="edit-btn trash-icon-b icon-b mr-2"
                        // data-toggle="tooltip"
                        // data-placement="top"
                        // title="Edit"
                        >
                          <svg
                            width="23"
                            height="22"
                            viewBox="0 0 23 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.4222 13.0012C19.4222 15.8012 19.4222 17.2013 18.8772 18.2713C18.4003 19.2126 17.6346 19.9764 16.6922 20.4512C15.6222 21.0012 14.2222 21.0012 11.4222 21.0012H9.42224C6.62224 21.0012 5.22224 21.0012 4.15224 20.4512C3.20984 19.9764 2.44416 19.2126 1.96724 18.2713C1.42224 17.2013 1.42224 15.8012 1.42224 13.0012V11.0012C1.42224 8.20125 1.42224 6.80123 1.96724 5.73123C2.44659 4.78921 3.21132 4.02279 4.15224 3.54129C5.22224 3.00129 6.62224 3.00125 9.42224 3.00125M7.48424 12.5012C7.49224 12.1512 7.49725 11.9813 7.53925 11.8113C7.57725 11.6613 7.63625 11.5313 7.71625 11.4013C7.80525 11.2513 7.92924 11.1313 8.17624 10.8813L17.5722 1.4313C17.8083 1.19426 18.1184 1.04508 18.451 1.00869C18.7835 0.972308 19.1185 1.05084 19.4002 1.23123C20.0877 1.67875 20.6745 2.26448 21.1232 2.9512C21.1482 2.9812 21.1742 3.02131 21.1982 3.06131C21.5742 3.67131 21.4512 4.4313 20.9582 4.9313L11.6362 14.3013C11.3792 14.5613 11.2512 14.6913 11.1022 14.7813C10.9685 14.8614 10.8241 14.9219 10.6732 14.9612C10.5032 15.0012 10.3222 15.0012 9.95924 15.0012H7.42224L7.48424 12.5012Z"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </button>
                        <button
                          type="button"
                          className="edit-btn trash-icon-b icon-b icon-s pe-3"
                          onClick={() => this.props.deleteSubTasks(this.props.node, 3)}
                        // data-toggle="tooltip"
                        // data-placement="top"
                        // title="Delete"
                        >
                          <i>
                            <DeleteRedIcon />
                          </i>
                        </button>
                      </div>
                    </div>
                    <div className="cont-4-card tbl">
                      <div className="inner-cont">{this.props.node.task[0]?.min_value}</div>
                      <div className="inner-cont">{this.props.node.task[0]?.max_value}</div>
                    </div>
                  </div>
                </div>
              ) : null}
              <div id={`collapseOne${randomno}`} className="collapse " aria-labelledby={`headingOne${randomno}`}>
                {/* {this.props.node.task[0].children ? */}
                {node}
                {/* : null} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class SubTask extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    var list = this.props.list;
    return (
      <div>
        {list.task_type === 1 ? (
          <div className="card mt-2 ml-3 mr-3 pb-2" id="in-q1">
            <div className="mb-0 pb-2 text-dark dv-center space-between">
              <div className="dv-center">
                <h6 className="text-dark mb-0 pl-3 pr-3 pt-3">
                  <span className="mr-2">
                    <i className="fa fa-th-list"></i>
                  </span>{" "}
                  {list.task[0].question}
                </h6>
              </div>
              <div style={{ transform: "translate(-7px, 8px)" }}>
                {list.is_mandatory ? (
                  <a className="badge badge-success mr-2">Compulsory</a>
                ) : (
                  <a className="badge badge-danger text-white mr-2">Non-Compulsory</a>
                )}

                <button
                  onClick={() => this.props.editTasks(list, "subTask")}
                  type="button"
                  className="edit-btn trash-icon-b icon-b mr-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Edit"
                >
                  <i>
                    {" "}
                    <EditIcon />
                  </i>
                  {/* <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    className="bi bi-pencil"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z"
                    />
                  </svg> */}
                </button>
                <button
                  type="button"
                  className="edit-btn trash-icon-b icon-b"
                  onClick={() => this.props.deleteTasks(list, 2)}
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Delete"
                >
                  <i>
                    <DeleteRedIcon />
                  </i>
                </button>
              </div>
            </div>
            <div className="cont-4-card tbl">
              <div className="inner-cont">{list.task[0].correct}</div>
              <div className="inner-cont">{list.task[0].alternative_1}</div>
              {list.task[0].mcq_type === 2 ? null : <div className="inner-cont">{list.task[0].alternative_2}</div>}
              {list.task[0].mcq_type === 2 ? null : <div className="inner-cont">{list.task[0].alternative_3}</div>}
            </div>
          </div>
        ) : null}
        {list.task_type === 2 ? (
          <div className="card mt-2 ml-3 mr-3 pb-2" id="in-q1">
            <div className="mb-0 pb-2 text-dark dv-center space-between">
              <div className="dv-center">
                <h6 className="text-dark mb-0 pl-3 pr-3 pt-3">
                  <span className="mr-2">
                    <i className="fa fa-sort-numeric-asc"></i>
                  </span>{" "}
                  {list.task[0].question}
                </h6>
              </div>
              <div style={{ transform: "translate(-7px, 8px)" }}>
                {list.is_mandatory ? (
                  <a className="badge badge-success mr-2">Compulsory </a>
                ) : (
                  <a className="badge badge-danger text-white mr-2">Non-Compulsory</a>
                )}

                <button
                  onClick={() => this.props.editTasks(list, "subTask")}
                  type="button"
                  className="edit-btn trash-icon-b icon-b mr-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Edit"
                >
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    className="bi bi-pencil"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  className="edit-btn trash-icon-b icon-b"
                  onClick={() => this.props.deleteTasks(list, 2)}
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Delete"
                >
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            </div>
            <div className="cont-4-card tbl">
              <div className="inner-cont">{list.task[0].min_value}</div>
              <div className="inner-cont">{list.task[0].max_value}</div>
            </div>
          </div>
        ) : null}
        {list.task_type === 3 ? (
          <div>
            <ParentChildSubTask
              node={list}
              children={list.children}
              editTasks={this.props.editTasks}
              index={0}
              deleteSubTasks={this.props.deleteSubTasks}
              showchild={true}
              AddSubTasks={this.props.AddSubTasks}
              editTasksType={"subTask"}
            />
          </div>
        ) : null}
        {list.task_type === 4 ? (
          <div className="card mt-2 ml-3 mr-3" id="in-q1">
            <div className="mb-0 pb-3 text-dark dv-center space-between">
              <div className="dv-center">
                <h6 className="text-dark mb-0 pl-3 pr-3 pt-3">
                  <span className="mr-2">
                    <i className="fa fa-check-circle"></i>
                  </span>
                  Trigger To : {list.trigger_id}
                </h6>
              </div>
              <div style={{ transform: "translate(-7px, 8px)" }}>
                {/* <button onClick={() => this.props.editTasks(list)} type="button" className="edit-btn trash-icon-b icon-b mr-2" data-toggle="tooltip" data-placement="top" title="Edit">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-pencil" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z" />
                                        <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z" />
                                    </svg>
                                </button> */}
                <button
                  type="button"
                  className="edit-btn trash-icon-b icon-b"
                  onClick={() => this.props.deleteTasksTypeFour(list, 2)}
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Delete"
                >
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

class ParentChildTree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggle4On: true,
    };
  }
  toggleHandler4 = () => {
    this.setState((state) => ({
      isToggle4On: !state.isToggle4On,
    }));
  };

  render() {
    var node = this.props.children
      ? this.props.children.map((li, index) => (
        <ParentChildTree
          node={li}
          children={li.children}
          index={index}
          addParentChild={this.props.addParentChild}
          radioParentChildBankSelect={this.props.radioParentChildBankSelect}
        />
      ))
      : null;
    var randomno = Math.floor(Math.random() * (999 - 100 + 1) + 100);
    return (
      <div>
        <div className="accordion o-f-y-h mb-2" id="accordion_task">
          <div className="stp2 ">
            <div className="form-content">
              <div className="hirquelists" border5x="rdius5">
                {this.props.node.child_type == 3 ? (
                  <div className="card pc-card" id="q1">
                    <div className="mb-0 text-white dv-center space-between">
                      <div className="dv-center">
                        {this.props.children && this.props.children.length > 0 && (
                          <button
                            onClick={this.toggleHandler4}
                            className="btn btn-link text-dark arrow-s"
                            type="button"
                            data-toggle="collapse"
                            data-target={`#collapseOne${randomno}`}
                            aria-expanded="true"
                            aria-controls={`#collapseOne${randomno}`}
                          >
                            <i className={this.state.isToggle4On ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                          </button>
                        )}
                        {this.props.node.parent_id == 0 ? (
                          <div
                            className={`custom-control custom-radio custom-control-inline ${this.props.children && this.props.children.length > 0 ? "" : "ml-2"
                              }`}
                          >
                            <input
                              type="radio"
                              id={`parent_child_list${randomno}`}
                              value={JSON.stringify(this.props.node)}
                              name="parent_child_list"
                              onChange={(e) => this.props.radioParentChildBankSelect(e)}
                              className="custom-control-input"
                            />
                            <label className="custom-control-label" for={`parent_child_list${randomno}`}></label>
                          </div>
                        ) : null}
                        {/* <input type="radio" id={`parent_child_list${randomno}`} value={this.props.node.id} onChange={(e) => this.props.radioParentChildBankSelect(e)} name="parentChild" className="custom-control-input" /> */}
                        <h6 className="text-dark mb-0"> {this.props.node.question}</h6>
                      </div>
                      <div>
                        <button
                          onClick={() => this.props.addParentChild(this.props.node)}
                          type="button"
                          className="edit-btn"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Add"
                          id="stp3-btn"
                        >
                          <i className="mdi mdi-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ) : null}
                {this.props.node.child_type == 1 ? (
                  <div className="card mt-2 ml-3 mr-3" id="in-q1">
                    <div className="mb-0 text-dark dv-center space-between">
                      <div className="dv-center">
                        {/* <button className="btn btn-link text-white" type="button" data-toggle="collapse" data-target={`#collapseOne${randomno}`} aria-expanded="true" aria-controls={`#collapseOne${randomno}`}>
                                                    <i className="fa fa-angle-down text-dark mr-1"></i>
                                                 </button> */}
                        <h6 className="text-dark mb-0 p-2">{this.props.node.question}</h6>
                      </div>
                      <div>
                        {/* <button onClick={() => this.props.addParentChild(this.props.node)} type="button" className="edit-btn text-dark" data-toggle="tooltip" data-placement="top" title="Add"><i className="mdi mdi-plus"></i></button> */}
                      </div>
                    </div>
                  </div>
                ) : null}
                {this.props.node.child_type == 2 ? (
                  <div className="card mt-2 ml-3 mr-3 mb-2" id="in-q1">
                    <div className="mb-0 text-dark dv-center space-between">
                      <div className="dv-center">
                        {/* <button className="btn btn-link text-white" type="button" data-toggle="collapse" data-target={`#collapseOne${randomno}`} aria-expanded="true" aria-controls={`#collapseOne${randomno}`}>
                                                    <i className="fa fa-angle-down text-dark mr-1"></i>
                                                </button> */}
                        <h6 className="text-dark mb-0 p-2"> {this.props.node.question} </h6>
                      </div>
                      <div>
                        {/* <button onClick={() => this.props.addParentChild(this.props.node)} type="button" className="edit-btn text-dark" data-toggle="tooltip" data-placement="top" title="Add"><i className="mdi mdi-plus"></i></button> */}
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="childhierarchy">
                  <div id={`collapseOne${randomno}`} className="collapse" aria-labelledby={`headingOne${randomno}`}>
                    {node}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class ParentChildTreeForAddChildsToParent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupForAdd: false,
      question_pc_child: "",
      selectedBankIdForTaskChild: null,
      parent_id: 0,
      isToggleOn: true,
      isToggle2On: true,
      childIsMandatry: true,
    };
  }

  toggleHandler = () => {
    this.setState((state) => ({
      isToggleOn: !state.isToggleOn,
    }));
  };
  toggleHandler2 = () => {
    this.setState((state) => ({
      isToggle2On: !state.isToggle2On,
    }));
  };
  addAnotherParentProcess = (id) => {
    this.setState({ popupForAdd: true, parent_id: id });
  };
  selectedMcqOrRangePC = (e) => {
    this.setState({ SelectedMcqOrRangePC: e.target.value });
    if (e.target.value == "MCQ") {
      this.props.fetchMcqBankList();
    } else if (e.target.value == "Range") {
      this.props.fetchRangeBankList();
    } else {
    }
  };
  radioRangeBankSelectChild = (e) => {
    this.setState({ selectedBankIdForTaskChild: e.target.value });
  };
  onChangeInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  addChild = () => {
    var data;
    if (this.state.SelectedMcqOrRangePC == "MCQ") {
      data = {
        task_type: 1,
        bank_id: this.state.selectedBankIdForTaskChild,
        value: this.state.selectedBankValue,
        parent_id: this.state.parent_id,
        is_mandatory: this.state.childIsMandatry ? 1 : 0,
      };
    } else if (this.state.SelectedMcqOrRangePC == "Range") {
      data = {
        task_type: 2,
        bank_id: this.state.selectedBankIdForTaskChild,
        value: this.state.selectedBankValue,
        parent_id: this.state.parent_id,
        is_mandatory: this.state.childIsMandatry ? 1 : 0,
      };
    } else if (this.state.SelectedMcqOrRangePC == "Parent") {
      data = {
        task_type: 3,
        bank_id: 0,
        value: this.state.question_pc_child,
        parent_id: this.state.parent_id,
        is_mandatory: this.state.childIsMandatry ? 1 : 0,
      };
    } else {
      return;
    }
    this.props.addAnotherChild(data);
    this.setState({ popupForAdd: false });
  };

  radioBankSelectChild = (e) => {
    this.setState({
      selectedBankIdForTaskChild: JSON.parse(e.target.value).id,
      selectedBankValue: JSON.parse(e.target.value).question,
    });
  };
  handleCheckboxChild = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.checked });
  };
  render() {
    var node = this.props.children
      ? this.props.children.map((li, index) => (
        <ParentChildTreeForAddChildsToParent
          node={li}
          children={li.children}
          index={index}
          onChangeInputParent={this.props.onChangeInputParent}
          fetchMcqBankList={this.props.fetchMcqBankList}
          fetchRangeBankList={this.props.fetchRangeBankList}
          mcqBankList={this.props.mcqBankList}
          rangeBankList={this.props.rangeBankList}
          addAnotherChild={this.props.addAnotherChild}
          deleteTempChild={this.props.deleteTempChild}
          handleMandatry={this.props.handleMandatry}
        />
      ))
      : null;
    var randomno = Math.floor(Math.random() * (999 - 100 + 1) + 100);

    const pop_in = {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      zIndex: "999",
      background: "#fff",
      padding: "1rem",
    };

    return (
      <div>
        {this.state.popupForAdd ? (
          <div className="accordion o-f-y-h mb-2 pop-up-show" style={pop_in}>
            <div className="stp2 ">
              <div className="form-content">
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <h4>Select MCQ, Range Or Question Hierarchy</h4>
                  </div>
                  <div className="form-group col-md-12 ml-2">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        value="MCQ"
                        id="customRadioInline4"
                        name="SelectMcqType"
                        onChange={this.selectedMcqOrRangePC}
                        className="custom-control-input"
                        checked={this.state.SelectedMcqOrRangePC === "MCQ"}
                      />
                      <label className="custom-control-label" for="customRadioInline4">
                        MCQ
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        value="Range"
                        id="customRadioInline5"
                        name="SelectMcqType"
                        onChange={this.selectedMcqOrRangePC}
                        className="custom-control-input"
                        checked={this.state.SelectedMcqOrRangePC === "Range"}
                      />
                      <label className="custom-control-label" for="customRadioInline5">
                        Range
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        value="Parent"
                        id="customRadioInline6"
                        name="SelectMcqType"
                        onChange={this.selectedMcqOrRangePC}
                        className="custom-control-input"
                        checked={this.state.SelectedMcqOrRangePC === "Parent"}
                      />
                      <label className="custom-control-label" for="customRadioInline6">
                        Question Hierarchy
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <input
                    type="checkbox"
                    className="ml-2 mr-2"
                    name="childIsMandatry"
                    onChange={() => this.setState({ childIsMandatry: !this.state.childIsMandatry })}
                    checked={this.state.childIsMandatry}
                  />
                  Is Mandatory
                </div>
                {this.state.SelectedMcqOrRangePC === "MCQ" ? (
                  <div className="mt-2 sticky-fixed">
                    {this.props.mcqBankList.map((list, index) => (
                      <div className="item">
                        <div className="custom-control custom-radio">
                          <input
                            type="radio"
                            id={`customRadio${index + 10}`}
                            value={JSON.stringify(list)}
                            onChange={this.radioBankSelectChild}
                            name={"list.question"}
                            className="custom-control-input"
                          />
                          <label className="custom-control-label" for={`customRadio${index + 10}`}>
                            {list.question}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
                {this.state.SelectedMcqOrRangePC === "Range" ? (
                  <div className="mt-2 sticky-fixed">
                    {this.props.rangeBankList.map((list, index) => (
                      <div className="item">
                        <div className="custom-control custom-radio">
                          <input
                            type="radio"
                            id={`customRadio${index + 10}`}
                            value={JSON.stringify(list)}
                            onChange={this.radioBankSelectChild}
                            name={"list.question"}
                            className="custom-control-input"
                          />
                          <label className="custom-control-label" for={`customRadio${index + 10}`}>
                            {list.question}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
                {this.state.SelectedMcqOrRangePC === "Parent" ? (
                  <div className="mt-2 sticky-fixed">
                    <input
                      type="text"
                      onChange={this.onChangeInput}
                      className="form-control"
                      name="question_pc_child"
                      value={this.state.parent}
                      id="inputText"
                      placeholder="Question..."
                    />
                  </div>
                ) : null}
              </div>
              <button
                type="button"
                style={{ position: "absolute", right: "2rem" }}
                onClick={this.addChild}
                className="btn btn-primary ml-2"
              >
                <i className="mdi mdi-plus"></i> Add Child
              </button>
            </div>
          </div>
        ) : (
          <div
            className="accordion o-f-y-h mb-2"
            id="accordion_task"
            style={{ marginLeft: this.props.node.parent_id == 0 ? "" : "1.5rem" }}
          >
            <div className="stp2 ">
              <div className="form-content">
                <div border5x="rdius5">
                  {this.props.node.task_type == 3 ? (
                    <div className="card pc-card" id="q1">
                      <div className="mb-0 text-white dv-center space-between">
                        <div className="dv-center">
                          <button
                            onClick={this.toggleHandler}
                            className="btn btn-link text-dark arrow-s"
                            type="button"
                            data-toggle="collapse"
                            data-target={`#collapseOne${randomno}`}
                            aria-expanded="true"
                            aria-controls={`#collapseOne${randomno}`}
                          >
                            <i className={this.state.isToggleOn ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                          </button>
                          {/* <h6 className="text-dark mb-0"> */}
                          <div className="text-dark">
                            <input
                              type="checkbox"
                              className="ml-2 mr-2"
                              name="childIsMandatry"
                              onChange={() => this.props.handleMandatry(this.props.node)}
                              checked={this.props.node.is_mandatory === 1 ? true : false}
                            />
                            Is Mandatory
                          </div>
                          <div className="custom-control form-content text-center" style={{ display: "flex" }}>
                            <input
                              type="text"
                              onChange={(e) => this.props.onChangeInputParent(e, this.props.node.index)}
                              className="question_pc_sub-input"
                              name="question_pc_sub"
                              value={this.props.node.value}
                              id="inputText"
                              placeholder="Question..."
                              style={{ width: "300px" }}
                            />
                          </div>

                          {/* </h6> */}
                        </div>
                        <div>
                          {this.props.node.parent_id == 0 ? (
                            ""
                          ) : (
                            <button
                              onClick={() => this.props.deleteTempChild(this.props.node)}
                              type="button"
                              className="edit-btn text-dark"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Delete"
                            >
                              <i className="fa fa-trash-o" aria-hidden="true"></i>
                            </button>
                          )}
                          <button
                            onClick={() => this.addAnotherParentProcess(this.props.node.id)}
                            type="button"
                            className="edit-btn"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Add"
                            id="stp3-btn"
                          >
                            <i className="mdi mdi-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.props.node.task_type == 1 ? (
                    <div className="card bg-secondary-rgba mt-2" id="in-q1">
                      <div className="mb-0 text-dark" style={{ display: "grid", gridTemplateColumns: "75% 25%" }}>
                        <div className="dv-center space-between">
                          <h6 className="text-dark mb-0 p-2">
                            <span className="mr-2">
                              <i className="fa fa-th-list"></i>
                            </span>
                            {this.props.node.value}
                          </h6>
                        </div>
                        <div className="dv-center mr-2">
                          <div className="text-dark mr-2">
                            <input
                              type="checkbox"
                              className="ml-2 mr-2"
                              name="childIsMandatry"
                              onChange={() => this.props.handleMandatry(this.props.node)}
                              checked={this.props.node.is_mandatory === 1 ? true : false}
                            />
                            Is Mandatory
                          </div>

                          <button
                            onClick={() => this.props.deleteTempChild(this.props.node)}
                            type="button"
                            className="edit-btn text-dark"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete"
                          >
                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.props.node.task_type == 2 ? (
                    <div className="card bg-secondary-rgba mt-2 mb-2" id="in-q1">
                      <div className="mb-0" style={{ display: "grid", gridTemplateColumns: "75% 25%" }}>
                        <div className="dv-center space-between">
                          {/* <button className="btn btn-link text-white" type="button" data-toggle="collapse" data-target={`#collapseOne${randomno}`} aria-expanded="true" aria-controls={`#collapseOne${randomno}`}>
                                                    <i className="fa fa-angle-down text-dark mr-1"></i>
                                                </button> */}
                          <h6 className="text-dark mb-0 p-2">
                            <span className="mr-2">
                              <i className="fa fa-sort-numeric-asc"></i>
                            </span>
                            {this.props.node.value}{" "}
                          </h6>
                        </div>
                        <div className="dv-center mr-2">
                          <div className="text-dark mr-2">
                            <input
                              type="checkbox"
                              className="ml-2 mr-2"
                              name="childIsMandatry"
                              onChange={() => this.props.handleMandatry(this.props.node)}
                              checked={this.props.node.is_mandatory === 1 ? true : false}
                            />
                            Is Mandatory
                          </div>
                          <button
                            onClick={() => this.props.deleteTempChild(this.props.node)}
                            type="button"
                            className="edit-btn text-dark"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete"
                          >
                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div
                    id={`collapseOne${randomno}`}
                    className="collapse mt-2 ml-3"
                    aria-labelledby={`headingOne${randomno}`}
                  >
                    {node}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
